import { RequestCategory } from "../interfaces";
import TempBillingImports from "../Pages/temp-billing-reports";

// -------------- ROUTES -----------------
export const COMPANIES_ROUTE = '/companies';
export const COMPANY_DETAILS_ROUTE = '/company-details';
export const UPDATE_COMPANY_ROUTE = '/update-company';
export const CONTACTS_ROUTE = '/contacts';
export const CONTACT_DETAIL_ROUTE = '/contact-details';
export const AGREEMENTS_ROUTE = '/agreements';
export const LEGACY_AGREEMENTS_ROUTE = '/legacy-agreements';
export const VIEW_AGREEMENT_ROUTE = '/view-agreement';
export const JOB_ORDER_ROUTE = '/job-orders';
export const VIEW_JOB_ORDER_ROUTE = '/view-job-order';
export const UPDATE_JOB_ORDER_ROUTE = '/update-job-order';
export const CANDIDATES_ROUTE = '/candidates';
export const VIEW_CANDIDATE_ROUTE = '/view-candidate';
export const UPDATE_CANDIDATE_ROUTE = '/update-candidate';
export const JOB_APPLICANTS_ROUTE = '/job-applicants';
export const JOB_LIST_ROUTE = '/job-list';
export const VIEW_JOB_APPLICANT_ROUTE = '/view-job-applicant';
export const UPDATE_JOB_APPLICANT_ROUTE = '/update-job-applicant';
export const CANDIDATE_SUBMISSION_ROUTE = '/candidate-submission';
export const CREATE_JOB_ORDER_ROUTE = '/create-job-order';
export const VIEW_PLACEMENT_MANAGEMENT_ROUTE = '/view-placements-management';
export const VIEW_ACCOUNTING_DASHBOARD_ROUTE = '/view-accounting-dashboard';
export const PLACEMENT_MANAGEMENT_ROUTE = '/placement-management';
export const ACCOUNTING_DASHBOARD_ROUTE = '/accounting-dashboard';
export const SYNONYM_ROUTE = '/synonyms';
export const MODULE_ROUTE = '/module';
export const CANDIDATE_SEARCH_DEV_ROUTE = '/candidate-search-dev';
export const CHATGPT_TEMPLATE_ROUTE = '/chatgpt-templates';
export const STARTER_INTERVIEW_QUESTIONS_ROUTE = '/starter-interview-questions';
// kan-111: admin-managed question list the AI Reference Taker voice agent asks.
export const AI_REFERENCE_QUESTIONS_ROUTE = '/ai-reference-questions';
export const IMPORT_CSV_ROUTE = '/import-csv';
export const TEMP_BILLING_IMPORTS_ROUTE = '/temp-billing-imports';
// kan-101: executive-only reconciliation of People 2.0 payments against the
// invoices they cover. Separate entry point from the imports listing above.
export const TEMP_BILLING_RECONCILIATION_ROUTE = '/temp-billing-reconciliation';
// Executive-only, append-only People 2.0 cost-rate periods (fee + employee
// burden) used to recompute "Owed to RealREPP" on the reconciliation page.
export const TEMP_BILLING_COST_RATES_ROUTE = '/temp-billing-cost-rates';
export const TEMP_BILLING_COST_RATES = 'Temp Billing Cost Rates';
export const BILLING_CREDITS_ADMIN_ROUTE = '/admin/billing-credits';
export const RESUME_PARSER_COMPARE_ROUTE = '/admin/resume-parser-compare';
export const ADMIN_IMPORT_CSV = '/admin-import-csv';
export const USER_ACTIVITY_REPORT_ROUTE = '/users-activity-reports';
export const EMAIL_TEMPLATES_ROUTE = '/email-templates';
export const AI_RECRUITER_HEALTH_ROUTE = '/ai-recruiter-health';
export const AI_RECRUITER_HEALTH = 'AI Recruiter Health';
export const RECRUITER_DEAL_TEMPLATES_ROUTE = '/recruiter-deal-templates';
export const UPDATE_CANDIDATE_BY_RESUME = '/candidate/update-by-resume'
export const RECRUITER_FOLDERS_ROUTE = '/recruiter-folders';
export const VIEW_RECRUITER_FOLDER_ROUTE = '/view-recruiter-folder';
export const SETTINGS_ROUTE = '/settings';
export const ADMIN_ROUTE = '/admin';
export const REQUESTS_ROUTE = '/request';
export const DASHBOARD_ROUTE = '/dashboard';
export const COMPANY_OWNERSHIP_REPORT_ROUTE = '/company-ownership-report';
export const LINKEDIN_FEED_REPORT_ROUTE = '/linkedin-feed-report';
export const CANDIDATE_OWNERSHIP_REPORT_ROUTE = '/candidate-ownership-report';
export const GOAL_SHEET_REPORT = '/goal-sheet-report'
export const ACTIVITY_DASHBOARD_ROUTE = '/activity-dashboard';
export const NEW_APPLICANTS_ROUTE = '/new-applicants';
export const INVOICE_AGING_ROUTE = '/invoice-aging';
export const CANDIDATE_RECOMMENDATIONS_ROUTE = '/candidate-recommendations';

export const SET_STATUS_OPTIONS = [
  { label: 'Called', value: 'CALLED' },
  { label: 'Emailed', value: 'EMAILED' },
  { label: 'Keep', value: 'KEEP' },
  { label: 'Contact Later', value: 'CONTACT_LATER' },
  { label: 'Call Scheduled', value: 'CALL_SCHEDULED' },
];

export const ROUTE_HISTORY_KEY = 'routeHistory';

export const LIST_ROUTES = [
  COMPANIES_ROUTE,
  CONTACTS_ROUTE,
  AGREEMENTS_ROUTE,
  LEGACY_AGREEMENTS_ROUTE,
  JOB_ORDER_ROUTE,
  CANDIDATES_ROUTE,
  JOB_APPLICANTS_ROUTE,
  PLACEMENT_MANAGEMENT_ROUTE,
  ACCOUNTING_DASHBOARD_ROUTE,
  RECRUITER_FOLDERS_ROUTE,
];

export const PARSE_RESUME_FILE_SIZE = 6291456;
export const MANUAL_RESUME_FILE_SIZE = 10485760;
export const EMAIL_PATTERN = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;
// /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// export const URL_REGEX = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

export const URL_REGEX =
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
// eslint-disable-next-line
export const PHONE_PATTERN = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
export const ONLY_NUMBER = /^\d*(\.\d+)?$/;

export const TWITTER_URL_REGEX =
  /(https?:\/\/twitter.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+))/;

export const INSTAGRAM_HANDLE_REGEX =
  /(?:^|[^\w])(?:@)([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/;

export const reactQuillReg = new RegExp(
  /^<p>(<br>|<br\/>|<br\s\/>|\s+|)<\/p>$/gm
);

// eslint-disable-next-line no-useless-escape
// export const numbRegex = /^[1-9]\d*(\,\d{0,9})*(\.\d{0,9})?$/;
export const numbRegex = /^-?[0-9]+(\.[0-9]*)?$/

export const interviewRound = [
  { label: 'First', value: 1 },
  { label: 'Second', value: 2 },
  { label: 'Third', value: 3 },
  { label: 'Fourth', value: 4 },
  { label: 'Fifth', value: 5 },
];

export const candidateInviteTemplates = [
  { label: 'Web Interview Template', value: 'WEB_INTERVIEW_TEMPLATE' },
];

export const bucketFolders = {
  team: 'teams',
  company: 'companies',
  user: 'users',
  agreement: 'agreements',
  candidate: 'candidates',
  interview: 'interviews',
  job: 'jobs',
  documents: 'documents',
  csv: 'csv',
  tempBilling: 'temp-billing-imports',
  invoiceAttachments: "invoiceAttachments"
};

export const RECRUITERS_DEAL_NAV_TABS = ['Deals and History', 'Payout Details']
export const CREATE = "Create"
export const UPDATE = "Update"
export const RECRUITER_DEAL_DRAWER_HEADING = " Recruiter Deal"
export const COMMISSION_OVERWRITE_DRAWER_HEADING = " Commission"
export const DEALS = "Deals"
export const BTN_CREATE_DEAL = 'Create Deal'
export const TECH_RECRUITER = "Tech Recruiter"
export const JOB_TITLE = "Job Title"
export const PHONE = "Email"
export const EMAIL = "Phone"
export const ACTIONS = "Actions"
export const EDIT = "Edit"
export const VIEW = "View"
export const VIEW_PDF = "View PDF"
export const SET_ACTIVE = "Set as Active"
export const SET_INACTIVE = "Set as Deactivated"
export const CLONE_DEAL = "Clone Deal"
export const VIEW_HISTORY = "View History"
export const HISTORY_STEPPER = [
  "Recruiter Mentor & Commission Percentage",
  "Non-Recoverable Draw",
  "Commission tier updated"
]

// recruitersDeal toasts response 
export const FAILED_USER_FETCH = "Unable to Fetch User"


export const ACCOUNTING_DASHBOARD_HEADER = [
  { IdSearch: 'ID' },
  { candidateSearch: 'Candidate' },
  { jobTitleSearch: 'Job Title' },
  { netFeeSearch: 'Net Fee' },
  { startDateSearch: 'Start Date' },
  { placeDateSearch: 'Place Date' },
  { placementTypeSearch: 'Type' },
  { statusSearch: 'Place Status' },
  { paidAtSearch: 'Paid On' },
  { jobOwnerSearch: 'Job Owner' },
  { accountManagerSearch: 'Acct Mgr' },
  { RecruiterSearch: 'Recruiter' },
  { workLocationSearch: 'Work Loc' },
];
export const CANDIDATE_HEADER = [
  // {  emptySearch: '' },
  { nameSearch: 'Name' },
  { jobTitleSearch: 'Job Title' },
  { emailSearch: 'Email' },
  { phoneSearch: 'Phone' },
  { locationSearch: 'Location' },
  { candidateStatusSearch: 'Candidate Status' },
  { resumeUpdatedSearch: 'Resume Updated' },
  { actions: 'Actions' },
];
export const AGREEMENT_HEADERS_COLUMN_SEARCH = [
  { companySearch: 'Company' },
  { contactSearch: 'Contact' },
  { nickNameSearch: 'Nickname' },
  { typeSearch: 'Type' },
  { accountManagerSearch: 'Account Manager' },
  { statusSearch: 'Agreement Status' },
  { commissionSearch: 'Fee' },
  { signedAt: 'Signed At' },
  { actions: 'Action' },
];


export const JOB_ORDER_WIDGETS_HEADER = [
  'Title',
  'Company',
  'Company Owner',
  'Job Owner',
  'Location',
  'Work Type',
  'Posted',
  'Status',
  'Main Contact',
  'Action',
];
export const JOB_ORDER_WIDGETS_HEADERS_SEARCHING = [
  { jobTitleSearch: 'Title' },
  { companySearch: 'Company' },
  { companyownerSearch: 'Company Owner' },
  { jobOwnerSearch: 'Job Owner' },
  { locationSearch: 'Location' },
  // {workTypeSearch:'Work Type'},
  { postedSearch: 'Posted' },
  { statusSearch: 'Job Status' },
  { mainContactSearch: 'Main Contact' },
  { actions: 'Actions' },
];
export const MY_EARNING_HEADER = [
  { idSearch: 'ID' },
  { companySearch: 'Company' },
  { candidateSearch: 'Candidate' },
  { jobTitleSearch: 'Job Title' },
  { startDateSearch: 'Start Date' },
  { invoiceSearch: 'Invoice #' },
  { dueDate: 'Due Date' },
  { rate: 'Rate' },
  { statusSearch: 'Status' },
  { side: 'AM/Rec' },
  { commission: 'Commission' },
  { payout: 'Payout' },
];

export const PLACEMENT_MANAGEMENT_HEADER = [
  { IdSearch: 'ID' },
  { candidateSearch: 'Candidate' },
  { jobTitleSearch: 'Job Title' },
  { startDateSearch: 'Start Date' },
  { placeDateSearch: 'Place Date' },
  { netFeeSearch: 'Net Fee' },
  { statusSearch: 'Place Status' },
  { placementTypeSearch: 'Type' },
  { accountManagerSearch: 'Acct Mgr' },
  { RecruiterSearch: 'Recruiter' },
  { workLocationSearch: 'Work Loc' },
  { Actions: 'Actions' },
];

export const COMPANY_HEADER_HEADER = [
  { companySearch: 'Company' },
  { locationSearch: 'Location' },
  { companyOwnerSearch: 'Company Owner' },
  { stausSearch: 'Status' },
  { phoneSearch: 'Phone' },
  { lastUpdateSearch: 'Last Update' },
  { companySizeSearch: 'Company Size' },
  { agreements: 'Agreements' },
  { actions: 'Actions' },
];
export const CONTACT_HEADER = [
  { fullNameSearch: 'Full Name' },
  { companyNameSearch: 'Company Name' },
  { titleSearch: 'Title' },
  { emailSearch: 'Email' },
  { contactStatusSearch: 'Contact Status' },
  { phoneSearch: 'Phone' },
  { agreements: 'Agreements' },
  { actions: 'Actions' },
];



export const ACCOUNTING_PLACEMENT_HEADER = [
  'ID',
  'Candidate',
  'Job Title',
  'Net Fee',
  'Start Date',
  'Place Date',
  'Placement Type',
  'Place Status',
  'Account Manager',
  'Actions',
];

export const REQUESTS_TABLE_HEADER = [
  'created by',
  'category',
  'note',
  'link',
  'status',
  'approved/rejected by',
  'updated at',
  'actions',
];

export const SYNONYMS_TABLE_HEADER = [
  'job title',
  'synonyms',
  'action',
]

export const TIMETOFILL_TABLE_HEADER = [
  'position',
  'job id',
  'company',
  'candidate',
  'location',
  'job received',
  'status',
  'action'
]

export const JOB_LIST_HEADER = [
  { owner: 'owner' },
  { recruiter: 'Recruiters' },
  { createdAt: 'Date' },
  { companySearch: 'Company' },
  { positionSearch: 'Position' },
  { description: "Description" },
  { location: 'Location' },
  { salary: 'Salary' },
  { candidates: 'Candidates' },
  { Interviews: 'Interviews' },
  { finalist: 'Finalist' },
  { urgency: 'Urgency' },
  { pipeline: 'Pipeline' },
  { ats: 'ATS' },
  { website: 'Website' },
  { linkedIn: 'LinkedIn' },
];

export const INVOICE_STATUS_LIST_HEADER = [
  'Last Update',
  'Status',
  'Notes',
  'Actions'
];

export const INVOICE_ATTACHMENT_LIST_HEADER = [
  'Name',
  'Attachment Type',
  'Amount',
  'Uploaded By',
  'Actions'
];

export const SKILL_SYNONYMS_TABLE_HEADER = [
  'skill terms',
  'synonyms',
  'action',
];

export const JOB_APPLICANT_WIDGETS_HEADER = [
  'Job Title',
  'Company',
  'Company Owner',
  'Location',
  'Work Type',
  'Applications',
  'Status',
  'Actions',
];

export const ACTIVITY_DASHBOARD_HEADER = [
  'Company / Job',
  'Candidate',
  'Stage',
  'Note',
  'Last Updated',
];

export const ACTIVITY_DASHBOARD_HEADER_SEARCH = [
  { companySearch: 'Company / Job' },
  { candidateSearch: 'Candidate' },
  { stageSearch: 'Stage' },
  { note: 'Note' },
  { lastUpdated: 'Last Updated' },
];

// Two-band header: the first two columns span both rows; the four count
// columns sit under two group headings (in-feed vs. all posted).
export const LINKEDIN_FEED_REPORT_HEADER = [
  '#',
  'Company Name',
  'Job Orders',
  'Job Ads',
  'Job Orders',
  'Job Ads',
];

export const LINKEDIN_FEED_REPORT_HEADER_GROUPS = [
  { label: 'In LinkedIn Feed', hint: 'Top 165 ads' },
  { label: 'All Posted', hint: 'Active, any flag, no cap' },
];

export const COMPANY_OWNERSHIP_REPORT_HEADER = [
  'Company Name',
  'AM',
  'Expiration Date',
  'Preferred Contact',
  'Primary Email',
  'Primary Phone',
  'Note',
  'Send Email',
  'Days to Expiration',
];

export const CANDIDATE_OWNERSHIP_REPORT_HEADER = [
  'Candidate Name',
  'Recruiter',
  'Expiration Date',
  'Recent Employment',
  'Primary Email',
  'Primary Phone',
  'Note',
  'Send Email',
  'Days to Expiration',
];

export const AGREEMENT_HEADERS = [
  'Company',
  'Contact',
  'Nickname',
  'Type',
  'Commission',
  'Document',
  'Action',
];

export const ACTIVE_WIDGETS_HEADER = [
  'Full Name',
  'Company Name',
  'Title/Position',
  'Primary Email',
  'Primary Phone',
  'Status',
  'Last Contacted',
  'Agreements',
  'Actions',
];

export const RECRUITER_LISTING_HEADER = [
  'Folder Name',
  'Total Count in folder',
  'Actions',
];

export const VIEW_RECRUITER_FOLDER_HEADER = [
  'Candidate Name',
  'Candidate Email',
  'Candidate Status',
  'Candidate Owner',
  'Job Title',
  'Current Company',
  'Action',
];

export const MODULE_HEADER = [
  'module',
  'access',
  'last access modified',
  'action'
]
export const MODULE_HEADER_CHATGPT = [
  'name',
  'llm',
  'model',
  'description',
  'last modified',
  'action'
]

export const EMAIL_TEMPLATES_HEADERS = [
  'module',
  'subject',
  'template',
  'last access modified',
  'action'
]
export const EXPECTATION_TARGETS_TOP_HEADERS = [
  { first: "Period", second: "" },
  { first: "Monthly", second: "Completed Submission" },
  { first: "Monthly", second: "Scheduled Interview" },
  { first: "Monthly Min", second: "Total Lookup" },
  { first: "Client", second: "# of Signed Agreement" },
  { first: "Monthly DH ", second: "Placement Credits" },
  // { first: "Am Declined", second: "Submission" },
]

export const BILLING_SUMMARY_TOP_HEADERS = [
  { first: "Period " },
  { first: "Accepted Placement" },
  { first: "Estimated Billing" },
  { first: "Monthly Dh Target" },
  { first: "Goal Over / (Under)" },
  { first: "% Complete Target" }
]
export const EXPECTATION_TARGETS_ROWS = [
  ["Weekly Ranges", "L-6 | M-8 | H-10", "L-4 | M-5 | H-6", "", "", ""],
  ["WEEKLY TARGET", "8", "5", "250", "1", ""],
  ["MONTHLY GOAL", "32", "20", "1000", "4", "2.5"]
]
export const EXPECTATIONS_CONSTANT_TABLE = [
  ["Expected Earning", "$200,100", "$150,150", "$120,000", "$110,000", "$102,500", "$80,000"],
  ["Annual Dh billing credit", "$478,000", "$367,000", "$300,000", "$275,000", "$250,000", "$200,000"],
  ["Monthly Avg DH Billing Credit", "$39,833", "$30,583", "$25,000", "$22,917", "$22,833", "$16,667"],
]

export const VIEW_RECRUITER_DEAL_DETAIL_ENTRIES = [
  'Recruiter Title', 'Deal Start Date', 'Deal End Date', 'Mentor Commission',
  'Draw', 'Recruiter draw Percentage', 'DH Base Rate', 'Contract Base Rate', 'Bi-Weekly Draw']

export const earningGoalOptions = [
  { label: "$200,100", value: "200100" },
  { label: "$150,150", value: "150150" },
  { label: "$120,000", value: "120000" },
  { label: "$110,000", value: "110000" },
  { label: "$102,500", value: "102500" },
  { label: "$80,000", value: "80000" }
]

export const notificationData = [
  { title: 'Agreement', count: 7 },
  { title: 'Submission', count: 62 },
  { title: 'Interviews', count: 3 },
  { title: 'Placement', count: 16 },
  { title: 'Accounting Dashboard', count: 1 },
  { title: 'Notification', count: 6 },
];

export const placementAccountsPersonStatusUpdation = [
  { value: 'ACCOUNTING_INVOICED', label: 'Accounting Invoiced' },
];

export const PLACEMENT_SOURCE = [{ label: 'Linkedin', value: 'Linkedin' }];

export const jobApplicantStatusForCandidate = [
  // { label: 'All', value: 'All' },
  { label: 'Applied', value: 'Applied' },
  { label: 'Called', value: 'Called' },
  { label: 'Emailed', value: 'Emailed' },
  { label: 'Keep', value: 'Keep' },
  { label: 'Contact Later', value: 'Contact Later' },
  { label: 'Call Scheduled', value: 'Call Scheduled' },
  { label: 'Submitted', value: 'Submitted' },
  { label: 'Interviewed', value: 'Interviewed' },
  { label: 'Offered', value: 'Offered' },
  { label: 'Declined', value: 'Declined' },
  { label: 'Client Decline', value: 'Client Decline' },
  { label: 'Candidate Decline', value: 'Candidate Decline' },
];

export const PLACEMENT_TYPE = [
  { label: 'Direct Hire', value: 'DIRECT_HIRE' },
  { label: 'Contract', value: 'CONTRACT' },
];

export const PLACEMENT_COMISSION = [
  { label: 'Flat Fee', value: 'FLAT_FEE' },
  { label: 'Percentage', value: 'PERCENTAGE' },
];

export const interviewType = [
  { label: 'In Person', value: 'IN_PERSON' },
  { label: 'Web Screening', value: 'WEB' },
  { label: 'Phone', value: 'PHONE' },
];

export const interviewDetailsNotesCategories = [
  { label: 'Interview Prep', value: 'Interview Prep' },
  { label: 'Interview Feedback', value: 'Interview Feedback' },
  { label: 'Client Interview Feedback', value: 'Client Interview Feedback' },
];

export const emailNotesCategoriesForContact = [
  { label: 'Email Sent', value: 'EMAIL_SENT' },
  { label: 'Email Received', value: 'EMAIL_RECEIVED' },
];

export const interviewStatusType = [
  { label: 'Schedule Next Interview', value: 'Schedule_Next_Interview' },
  { label: 'Move To Offer', value: 'MOVE_TO_OFFER' },
  { label: 'Client Declined', value: 'CLIENT_DECLINED' },
  { label: 'Candidate Declined', value: 'CANDIDATE_DECLINED' },
];

export const submissionActionTypes = [
  { label: 'Submit', value: 'SUBMIT' },
  // { label: 'Feedback', value: 'FEEDBACK' },
  { label: 'Decline Submission', value: 'DECLINE_SUBMISSION' },
  { label: 'Reject Submission', value: 'REJECT_SUBMISSION' },
];
export const offerStatusType = [
  { label: 'Add Note', value: 'ADD_NOTE' },
  { label: 'Move To Placement', value: 'MOVE_TO_PLACEMENT' },
  { label: 'Client Declined', value: 'CLIENT_DECLINED' },
  { label: 'Candidate Declined', value: 'CANDIDATE_DECLINED' },
];

export const interviewAddNotesCategories = [
  { label: 'Move To Client Reject', value: 'Move To Client Reject' },
  { label: 'Move To Candidate Reject', value: 'Move To Candidate Reject' },
  { label: 'Schedule Interview', value: 'Schedule Interview' },
];

export const feedBackCategory = [
  { label: 'Internal Submission Note', value: 'Internal Submission Note' },
  { label: 'Client Submission Feedback', value: 'Client Submission Feedback' },
  { label: 'Client Interview Feedback', value: 'Client Interview Feedback' },
  {
    label: 'Candidate Interview Feedback',
    value: 'Candidate Interview Feedback',
  },
  { label: 'Client Interview Followup', value: 'Client Interview Followup' },
  { label: 'Candidate Withdrawn', value: 'Candidate Withdrawn' },
  { label: 'Candidate Offer Feedback', value: 'Candidate Offer Feedback' },
  { label: 'Client Offer Feedback', value: 'Client Offer Feedback' },
  { label: 'Client Withdrawn', value: 'Client Withdrawn' },
];

export const calendarInviteType = [
  { label: 'Client', value: 'CLIENT' },
  { label: 'Candidate', value: 'CANDIDATE' },
];

export const MonthFull = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const JOB_APPLICANTS_HEADER = [
  '',
  'APPLICANT NAME',
  'CURRENT JOB TITLE',
  'CURRENT COMPANY',
  'SOURCE',
  'CANDIDATE OWNER',
  // "SKILLS",
  'Job Status',
  'APPLY DATE',
  'ACTIONS',
];

export const ROLES = {
  ADMIN: 'ADMIN',
  EXECUTIVE: 'EXECUTIVE',
  RECRUITER: 'RECRUITER',
  MANAGER: 'MANAGER',
  ACCOUNTING_MANAGER: 'ACCOUNTING_MANAGER',
  HR: 'HR',
  ACCOUNTING_COORDINATOR: 'ACCOUNTING_COORDINATOR',
  // kan-66. The GraphQL enum KEY, not the DB value 'AI Recruiter' — the browser
  // receives the serialized key from the code-first UserRolesEnum.
  AI_RECRUITER: 'AI_RECRUITER',
};

export const JobOrderStatusDto = {
  DRAFT: 'Draft',
  ACTIVE: 'Active',
  CLOSE: 'Close',
  HOLD: 'Hold',
  FILLED_BY_US: 'Filled By Us',
  FILLED_BY_CLIENT: 'Filled By Client',
  CANCELLED: 'Cancelled',
  LOST_TO_COMPETITOR: 'Lost To Competitor',
  DUPLICATED_JOB: 'Duplicated Job',
};
export const timeZoneArray = {
  US: [
    { label: 'GMT', value: '+00:00' },
    { label: 'PST', value: '-08:00' },
    { label: 'PDT', value: '-07:00' },
    { label: 'MST', value: '-07:00' },
    { label: 'MDT', value: '-06:00' },
    { label: 'CST', value: '-06:00' },
    { label: 'CDT', value: '-05:00' },
    { label: 'EST', value: '-05:00' },
    { label: 'EDT', value: '-04:00' },
  ],
};

export const FeeTypeDto = {
  PERCENTAGE: 'Percentage',
  FIXED_FEE: 'Fixed Fee',
};

export const RecruitingLevelDto = {
  PRIVATE: 'Private',
  TEAM: 'Team',
  OPEN: 'Open',
};

export const RateTypeDto = {
  ANNUAL: 'Annual',
  HOURLY: 'Hourly',
};

export const workplaceTypesDto = {
  ONSITE: 'On-site',
  HYBRID: 'Hybrid',
  REMOTE: 'Remote',
};
export const paymentTypeDto = {
  WIRED: 'wired',
  CHECK: 'check',
};

export const moducleAcessDTO = {
  CHATGPT: 'ChatGPT',
  RESUME_REFORMATTER: 'Resume Reformater',
  ADVANCE_CANDIDATE_SEARCH: "Advance Candidate Search",
  JOB_LIST: "Job List",
  AI_MATCH_SCORING: "AI Match Scoring",
  AGED_INVOICES: "Aged Invoices",
  CANDIDATE_RECOMMENDATIONS: "Candidate Recommendations",
  MY_EARNING: 'My Earning',
  AI_REFERENCE_TAKER: 'AI Reference Taker',
};

export const chatGPtDTO = {
  GOOD_HAVE_SKILS: 'Good Have Skills',
  INTERVIEW_QUESTIONS: 'Interview Questions',
  MUST_HAVE_SKILS: 'Must Have Skills',
  RESUME_REFORMATTER: 'Resume Reformater',
  RESUME_SUMMARY: 'Resume Summary',
  UPDATE_CANDIDATE_FROM_RESUME: 'Update Candidate From Resume',
};


export const paymentType = [
  { label: 'wired', value: 'WIRED' },
  { label: 'check', value: 'CHECK' },
];

export const reportCategory = [
  { label: 'Team Report', value: 'TEAM_REPORT' },
  { label: 'Recruiter Report', value: 'RECRUITER_REPORT' },
  { label: 'Company Report', value: 'COMPANY_REPORT' },
  { label: 'Executive & HR Report', value: 'EXECUTIVE_AND_HR_REPORT' },
];

export const realReppDocumentCategory = [
  { label: 'HR Documents', value: 'HR_DOCUMENTS' },
  { label: 'Training Documents', value: 'TRAINING_DOCUMENTS' },
  { label: 'Benefit Documents', value: 'BENEFIT_DOCUMENTS' }
];

export const requestsCategory: RequestCategory[] = [
  { label: 'Company Ownership', value: 'COMPANY_OWNERSHIP' },
  { label: 'Placement Cancellation', value: 'PLACEMENT_CANCELLATION' },
]

export const synonymsType: RequestCategory[] = [
  { label: 'Skill Synonyms', value: 'SKILL_SYNONYMS' },
  { label: 'Job Title Synonyms', value: 'JOB_TITLE_SYNONYMS' },
]

export const JobType = [
  { label: 'Warm', value: 'WARM' },
  { label: 'Hold', value: 'HOLD' },
  { label: 'Reference', value: 'REFERENCE' },
  { label: 'None', value: 'NONE' }
]


export const JOB_TITLE_SYNONYMS = 'JOB_TITLE_SYNONYMS';
export const SKILL_SYNONYMS = 'SKILL_SYNONYMS';


export const requestsStatus = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Approved', value: 'APPROVED' },
  { label: 'Declined', value: 'DECLINED' },
]

export const customStylesReportEditDropdown = {
  control: (styles, provided) => ({
    ...styles,

    fontSize: 12,
  }),

  option: (provided, state) => ({
    ...provided,
    fontSize: 12,
  }),

  container: (provided, state) => ({
    ...provided,
    fontSize: 12,
  }),
};

export const customStylesEmploymentHistory = {
  control: (styles, provided) => ({
    ...styles,

    fontSize: 12,
  }),

  option: (provided, state) => ({
    ...provided,
    fontSize: 12,
  }),

  container: (provided, state) => ({
    ...provided,
    fontSize: 12,
  }),
};

export const WorkTypeDto = {
  DIRECT_HIRE: 'Direct Hire',
  TEMP: 'Temp',
};
export const PAGE_LIMIT = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
];

export const PAGE_LIMIT_MIN = [
  { value: 3, label: '3' },
  { value: 5, label: '5' },
  { value: 10, label: '10' },
  { value: 30, label: '30' },
  { value: 50, label: '50' },
];

export const ALL_REPORT_OPTIONS = [
  { value: 'Current', label: 'Current' },
  { value: 'Expiring within 30 days', label: 'Expiring within 30 days' },
];

export const INVOICE_ATTACHMENT_TYPE_OPTIONS = [
  { label: 'Invoice', value: 'INVOICE' },
  { label: 'Check', value: 'CHECK' },
  { label: 'Wired', value: 'WIRED' },
]
export const COMPANY_REPORT_OPTIONS = [
  { value: 'Expired within last 30 days', label: 'Expired within last 30 days' },
  { value: 'Expired within last 60 days', label: 'Expired within last 60 days' },
  { value: 'Expired within last 90 days', label: 'Expired within last 90 days' },
  { value: 'Expired longer than 90 days', label: 'Expired longer than 90 days' },
];
export const REFERENCE_STATUS = [
  { value: 'PENDING', label: 'PENDING' },
  { value: 'COMPLETED', label: 'COMPLETED' },
];

//this code is use for user statuts options in add or edit user screen
type SelectOptionsType = {
  label: string;
  value: string;
};
export const STATUS_CODE = {
  CODE_200: 200,
};

export const placementUpdateStatusPermission = [
  'DRAFT',
  'PENDING_AM',
  'PENDING_MANAGER',
  'PENDING_RECRUITER',
];

export const accountingPlacementManagement = [
  { value: 'PENDING_ACCOUNTING', label: 'Pending Accounting' },
  { value: 'ACCOUNTING_APPROVED', label: 'Accounting Approved' },
  { value: 'ACCOUNTING_INVOICED', label: 'Accounting Invoiced' },
  { value: 'REJECTED_ACCOUNTING', label: 'Rejected (Accounting)' },
  { value: 'PLACEMENT_CANCELLED', label: 'Placement Cancelled' },
];

export const PLACEMENT_CANCELLED = 'PLACEMENT_CANCELLED';
export const PLACEMENT_ENDED = 'PLACEMENT_ENDED';

export const placementManagement = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'PENDING_AM', label: 'Pending_AM' },
  { value: 'PENDING_MANAGER', label: 'Pending_Mgr' },
  { value: 'PENDING_RECRUITER', label: 'Pending_Rec' },
  { value: 'PENDING_ACCOUNTING', label: 'Pending_Acctg' },
  { value: 'ACCOUNTING_APPROVED', label: 'Acctg_Apprvd' },
  // { value: "ACCOUNTING_CONFIRMED", label: "Accounting Confirmed" },
  { value: 'ACCOUNTING_INVOICED', label: 'Acctg_Invoiced' },
  { value: 'PLACEMENT_CANCELLED', label: 'Placement_Cancelled' },
  { value: 'REJECTED_AM', label: 'Rejected_AM' },
  { value: 'REJECTED_MANAGER', label: 'Rejected_Mgr' },
  { value: 'REJECTED_ACCOUNTING', label: 'Rejected_Acctg' },
  { value: 'REJECTED_RECRUITER', label: 'Rejected_Rec' },
  { value: 'ASSIGNMENT_COMPLETED', label: 'Assgmnt_Completed' },
  { value: 'ASSIGNMENT_CANCELLED', label: 'Assgmnt_Cancelled' },
  { value: 'ASSIGNMENT_CONVERTED', label: 'Assgmnt_Converted' },
  { value: 'PLACEMENT_ENDED', label: 'Placement_Ended' },
  { value: 'REQUEST_PLACEMENT_CANCELLED', label: 'Cancelation_Request' },
  { value: 'PAID', label: 'Paid' },

];
export const ACCOUNTING_BOARD = [

  { value: 'PENDING_ACCOUNTING', label: 'Pending_Acctg' },
  { value: 'ACCOUNTING_APPROVED', label: 'Acctg_Apprvd' },
  // { value: "ACCOUNTING_CONFIRMED", label: "Accounting Confirmed" },
  { value: 'ACCOUNTING_INVOICED', label: 'Acctg_Invoiced' },
  { value: 'PLACEMENT_CANCELLED', label: 'Placement_Cancelled' },
  { value: 'REJECTED_ACCOUNTING', label: 'Rejected_Acctg' },
  { value: 'PAID', label: 'Paid' },

];
export const MONTHS = [
  { value: '1', label: 'January' },
  { value: '2', label: 'February' },
  { value: '3', label: 'March' },
  { value: '4', label: 'April' },
  { value: '5', label: 'May' },
  { value: '6', label: 'June' },
  { value: '7', label: 'July' },
  { value: '8', label: 'August' },
  { value: '9', label: 'September' },
  { value: '10', label: 'October' },
  { value: '10', label: 'November' },
  { value: '12', label: 'December' },
];
export const USER_STATUS = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'ON_LEAVE', label: 'On Leave' },
  { value: 'SUSPENDED', label: 'Suspended' },
  { value: 'TERMINATED', label: 'Terminated' },
  { value: 'NEW_HIRE', label: 'New Hire' },
];


export const SELECT_STATUS: Array<SelectOptionsType> = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'ON_LEAVE', label: 'On Leave' },
  { value: 'SUSPENDED', label: 'Suspended' },
  { value: 'TERMINATED', label: 'Terminated' },
];

export const SIGN_OUT = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5027 12.2967L13.5025 12.297C13.4362 12.3627 13.3575 12.4145 13.271 12.4494C13.1847 12.4841 13.0925 12.5013 12.9995 12.5M13.5027 12.2967L12.5036 12.297C12.569 12.3619 12.6466 12.4132 12.7319 12.448C12.8168 12.4827 12.9078 12.5004 12.9995 12.5M13.5027 12.2967L15.3024 10.497C15.3025 10.4969 15.3025 10.4969 15.3026 10.4968C15.3681 10.4318 15.4202 10.3544 15.4557 10.2692C15.4912 10.1839 15.5095 10.0924 15.5095 9.99999C15.5095 9.90758 15.4912 9.81609 15.4557 9.73079C15.4202 9.64556 15.3681 9.56819 15.3026 9.50315C15.3026 9.5031 15.3025 9.50304 15.3024 9.50299L13.5027 7.70328C13.371 7.57154 13.1923 7.49753 13.006 7.49753C12.8197 7.49753 12.641 7.57154 12.5093 7.70328C12.3776 7.83501 12.3036 8.01369 12.3036 8.19999C12.3036 8.38629 12.3776 8.56496 12.5093 8.6967L13.8124 9.99983M13.5027 12.2967L13.8124 9.99983M12.9995 12.5C12.9992 12.5 12.9988 12.5 12.9985 12.5L13 12.4L13.0006 12.5C13.0003 12.5 12.9999 12.5 12.9995 12.5ZM13.8124 9.99983L12.5036 11.303C12.5036 11.303 12.5036 11.303 12.5036 11.303L13.8124 9.99983Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
    />
    <path
      d="M5.19998 10.7H14.8C14.9856 10.7 15.1637 10.6263 15.295 10.495C15.4262 10.3637 15.5 10.1857 15.5 10C15.5 9.81437 15.4262 9.63633 15.295 9.50505C15.1637 9.37377 14.9856 9.30002 14.8 9.30002H5.19998C5.01432 9.30002 4.83628 9.37377 4.705 9.50505C4.57373 9.63633 4.49998 9.81437 4.49998 10C4.49998 10.1857 4.57373 10.3637 4.705 10.495C4.83628 10.6263 5.01432 10.7 5.19998 10.7Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
    />
    <path
      d="M1.6 19.1H11.2C11.3857 19.1 11.5637 19.0263 11.695 18.895C11.8263 18.7637 11.9 18.5857 11.9 18.4V13.6C11.9 13.4143 11.8263 13.2363 11.695 13.105C11.5637 12.9738 11.3857 12.9 11.2 12.9C11.0143 12.9 10.8363 12.9738 10.705 13.105C10.5737 13.2363 10.5 13.4143 10.5 13.6V17.7H2.3V2.3H10.5V6.4C10.5 6.58565 10.5737 6.7637 10.705 6.89497C10.8363 7.02625 11.0143 7.1 11.2 7.1C11.3857 7.1 11.5637 7.02625 11.695 6.89497C11.8263 6.7637 11.9 6.58565 11.9 6.4V1.6C11.9 1.41435 11.8263 1.2363 11.695 1.10503C11.5637 0.97375 11.3857 0.9 11.2 0.9H1.6C1.41435 0.9 1.2363 0.97375 1.10503 1.10503C0.97375 1.2363 0.9 1.41435 0.9 1.6V18.4C0.9 18.5857 0.97375 18.7637 1.10503 18.895C1.2363 19.0263 1.41435 19.1 1.6 19.1Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
    />
  </svg>
);

export const BACK_ICON = () => (
  <svg
    width="20"
    height="10"
    viewBox="0 0 20 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 9L1 5M1 5L5 1M1 5L19 5"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DASHBOARD = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711C0.683417 9.09763 1.31658 9.09763 1.70711 8.70711L2 8.41421V15C2 15.5523 2.44772 16 3 16H5C5.55228 16 6 15.5523 6 15V13C6 12.4477 6.44772 12 7 12H9C9.55229 12 10 12.4477 10 13V15C10 15.5523 10.4477 16 11 16H13C13.5523 16 14 15.5523 14 15V8.41421L14.2929 8.70711C14.6834 9.09763 15.3166 9.09763 15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L8.70711 0.292893Z"
      fill="#686E78"
    />
  </svg>
);

export const REPORTS = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="stroke"
  >
    <path
      d="M7.25 16.4167V10.9167C7.25 9.90414 6.42919 9.08333 5.41667 9.08333H3.58333C2.57081 9.08333 1.75 9.90414 1.75 10.9167V16.4167C1.75 17.4292 2.57081 18.25 3.58333 18.25H5.41667C6.42919 18.25 7.25 17.4292 7.25 16.4167ZM7.25 16.4167V7.25C7.25 6.23748 8.07081 5.41667 9.08333 5.41667H10.9167C11.9292 5.41667 12.75 6.23748 12.75 7.25V16.4167M7.25 16.4167C7.25 17.4292 8.07081 18.25 9.08333 18.25H10.9167C11.9292 18.25 12.75 17.4292 12.75 16.4167M12.75 16.4167V3.58333C12.75 2.57081 13.5708 1.75 14.5833 1.75H16.4167C17.4292 1.75 18.25 2.57081 18.25 3.58333V16.4167C18.25 17.4292 17.4292 18.25 16.4167 18.25H14.5833C13.5708 18.25 12.75 17.4292 12.75 16.4167Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SETTINGS = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8141 4.04985C13.5958 3.54439 12.9939 3.16075 12.4746 3.19715C11.9553 3.23356 11.3549 3.03053 11.0889 2.7771C10.823 2.52367 10.6074 1.9244 10.627 1.40214C10.6466 0.879882 10.2449 0.294613 9.73123 0.090189C9.21755 -0.114235 8.5233 0.0411832 8.18177 0.431829C7.84025 0.822475 7.26778 1.10951 6.90386 1.12071C6.53994 1.13191 5.96046 0.858879 5.60774 0.478035C5.25502 0.0971898 4.55377 -0.0386262 4.04849 0.179799C3.5432 0.398225 3.15688 1.0003 3.19327 1.51976C3.22967 2.03922 3.02671 2.63989 2.77337 2.90592C2.52002 3.17195 1.92095 3.38478 1.40167 3.36797C0.882384 3.35117 0.294513 3.75162 0.0901585 4.26548C-0.114196 4.77934 0.0411693 5.47382 0.431683 5.81546C0.822197 6.1571 1.10913 6.72977 1.12033 7.09241C1.13153 7.45505 0.859989 8.03612 0.477873 8.38896C0.0957573 8.7418 -0.0414125 9.44189 0.179739 9.95015C0.40089 10.4584 0.999958 10.8421 1.51924 10.8056C2.03853 10.7692 2.639 10.9723 2.90494 11.2257C3.17088 11.4791 3.38643 12.0756 3.36684 12.5979C3.34724 13.1201 3.74895 13.7054 4.26404 13.9098C4.77912 14.1142 5.47197 13.9588 5.8135 13.5682C6.15502 13.1775 6.7261 12.8905 7.09002 12.8849C7.45394 12.8793 8.03341 13.1495 8.38893 13.5304C8.74445 13.9112 9.4443 14.0414 9.94958 13.823C10.4549 13.6046 10.8412 13.0053 10.8048 12.4858C10.7684 11.9664 10.9714 11.3657 11.2247 11.0997C11.478 10.8336 12.0757 10.6208 12.5978 10.6418C13.1199 10.6628 13.705 10.2596 13.9093 9.74432C14.1137 9.22906 13.9611 8.53598 13.5678 8.19154C13.1745 7.8471 12.8875 7.28143 12.8777 6.91319C12.8679 6.54495 13.1395 5.96948 13.523 5.61664C13.7141 5.40942 13.8428 5.15242 13.8943 4.87523C13.9458 4.59804 13.918 4.31193 13.8141 4.04985ZM8.0754 9.50209C7.58077 9.71602 7.03383 9.77837 6.50377 9.68126C5.9737 9.58415 5.48435 9.33193 5.09762 8.95654C4.71089 8.58114 4.44417 8.09942 4.33119 7.57234C4.21822 7.04527 4.26407 6.49651 4.46296 5.99551C4.66184 5.4945 5.00481 5.06377 5.44848 4.75781C5.89215 4.45185 6.41657 4.28441 6.95539 4.27668C7.49421 4.26895 8.02322 4.42127 8.47547 4.71437C8.92773 5.00747 9.28292 5.42818 9.49608 5.92327C9.78185 6.58585 9.7932 7.33476 9.52764 8.00569C9.26209 8.67663 8.74132 9.21479 8.0796 9.50209H8.0754Z"
      fill="currentColor"
    />
  </svg>
);

export const REQUESTS = () => (
  <svg width="18" height="18" fill="currentColor" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.169434 8.99963C0.169434 4.12272 4.12296 0.169189 8.99988 0.169189C13.8768 0.169189 17.8303 4.12272 17.8303 8.99963C17.8303 13.8765 13.8768 17.8301 8.99988 17.8301C4.12296 17.8301 0.169434 13.8765 0.169434 8.99963ZM8.99988 1.43585C4.82252 1.43585 1.43611 4.82228 1.43611 8.99963C1.43611 13.1769 4.82252 16.5635 8.99988 16.5635C13.1772 16.5635 16.5636 13.1769 16.5636 8.99963C16.5636 4.82228 13.1772 1.43585 8.99988 1.43585ZM9.99991 13C9.99991 13.5523 9.55219 14 8.99991 14C8.44761 14 7.99991 13.5523 7.99991 13C7.99991 12.4477 8.44761 12 8.99991 12C9.55219 12 9.99991 12.4477 9.99991 13ZM7.06671 7.33333C7.06671 6.42948 7.84681 5.56667 9.00004 5.56667C10.1533 5.56667 10.9334 6.42948 10.9334 7.33333C10.9334 7.98824 10.5734 8.32283 9.95263 8.69992C9.88335 8.74201 9.80344 8.78841 9.71796 8.83805C9.47369 8.97991 9.18384 9.14825 8.96599 9.31799C8.64285 9.56976 8.26671 9.97597 8.26671 10.6C8.26672 11.005 8.59504 11.3333 9.00005 11.3333C9.4032 11.3333 9.73037 11.008 9.73336 10.6056L9.73408 10.6044C9.74565 10.5861 9.77991 10.5431 9.86744 10.4749C10.0028 10.3695 10.1534 10.2822 10.3542 10.1658C10.4589 10.1051 10.5773 10.0365 10.7141 9.95341C11.4267 9.52051 12.4 8.80509 12.4 7.33333C12.4 5.57052 10.9135 4.1 9.00004 4.1C7.08661 4.1 5.60004 5.57052 5.60004 7.33333C5.60004 7.73835 5.92837 8.06667 6.33337 8.06667C6.73839 8.06667 7.06671 7.73835 7.06671 7.33333Z" fill="currentColor" />
  </svg>
)

export const ADMIN = () => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16547 0.141089C7.06981 0.0611309 6.93019 0.0611218 6.83457 0.141126C4.97581 1.69634 2.66934 2.6156 0.244181 2.72591C0.108488 2.73208 0 2.84275 0 2.97859V11.6257C0 11.6615 0.00767718 11.697 0.0227513 11.7295C1.15544 14.1715 3.33532 15.9945 5.99565 16.7325L6.9321 16.9819C6.97651 16.9937 7.02331 16.9931 7.06738 16.9801L8.00435 16.7028C10.6826 15.9895 12.8739 14.1469 14 11.6503V2.9758C14 2.84108 13.8932 2.73088 13.7587 2.72343C11.3325 2.58917 9.02496 1.69539 7.16547 0.141089ZM9.16677 11.2451C9.20189 11.4484 8.98948 11.6043 8.80601 11.5099L7 10.5804L5.19399 11.5099C5.01052 11.6043 4.79811 11.4484 4.83323 11.2451L5.17391 9.27273L3.71858 7.87524C3.56815 7.7308 3.65029 7.47653 3.85678 7.44737L5.87391 7.16259L6.77686 5.37526C6.86932 5.19223 7.13068 5.19223 7.22314 5.37526L8.12609 7.16259L10.1432 7.44737C10.3497 7.47653 10.4318 7.7308 10.2814 7.87524L8.82609 9.27273L9.16677 11.2451Z"
      fill="currentColor"
    />
  </svg>
);

export const IMPERSONATE = () => (
  <svg
    width="20"
    height="13"
    viewBox="0 0 20 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.48294 4.24102L7.46704 4.20694L7.48237 4.00872C7.54343 3.5393 8.20028 2.9364 9.05223 2.35622C8.35022 1.97512 7.00443 1.58805 5.42861 1.35263C3.16555 1.01469 1.26088 1.11238 1.03398 1.56306L1.007 1.55908C0.790887 2.79782 -0.0460097 7.66926 0.00198334 8.48713C0.0107868 8.63622 0.0156144 8.73675 0.0198742 8.81314C-0.00568427 9.4166 0.113589 9.984 0.345034 10.4574C0.350714 10.4861 0.355542 10.5094 0.361789 10.5392C1.03454 12.0574 2.84039 12.6009 3.5671 12.7619C3.56597 12.767 3.56483 12.7753 3.56483 12.7753C3.56483 12.7753 3.62475 12.7841 3.72301 12.7946C3.81956 12.813 3.87977 12.8221 3.87977 12.8221C3.87977 12.8221 3.8809 12.8142 3.88147 12.8088C4.5565 12.8622 6.17236 12.8625 7.27847 11.9188C7.92652 11.4593 8.42377 10.6508 8.56946 9.67531C8.56974 9.67446 8.56974 9.67332 8.57002 9.67247C8.68106 9.29818 8.83328 8.41358 8.98805 7.39095C8.41412 6.21811 7.83763 4.99726 7.48294 4.24102ZM1.7658 5.13244C1.86065 4.49802 2.4519 4.06069 3.08603 4.15554C3.72045 4.25067 4.15779 4.84136 4.06322 5.47577C3.96837 6.11048 3.37712 6.54781 2.7427 6.45296C2.10857 6.35839 1.67095 5.76714 1.7658 5.13244ZM6.89084 11.11L1.29325 10.2737C1.45853 9.26268 2.82789 8.63111 4.36566 8.86056C5.90343 9.09059 7.02828 10.095 6.89084 11.11ZM7.89415 6.04857C7.7993 6.68298 7.20833 7.12032 6.57391 7.02547C5.93978 6.93062 5.50216 6.33937 5.59701 5.70523C5.69186 5.07081 6.28311 4.63348 6.91725 4.72833C7.55166 4.8229 7.989 5.41415 7.89415 6.04857Z"
      fill="currentColor"
    />
    <path
      d="M18.7173 6.36804L18.7159 6.36549L18.7153 6.36435C18.393 5.3954 16.2839 1.38188 15.6452 0.175233L15.5802 0.0525527L15.5021 0.0920263C14.8855 -0.258124 12.8718 0.445017 11.1801 1.28845C9.48845 2.13187 7.71527 3.31693 7.62382 4.01979L7.61133 4.18052C8.2253 5.49025 10.268 9.81389 10.7792 10.4599L10.9532 10.6823C11.3028 11.2219 11.739 11.6399 12.2329 11.9134L12.2442 11.9242L12.2882 11.9679C13.6826 12.8093 15.4027 12.3175 16.193 12.0096L16.1981 12.0193L16.3316 11.9676C16.3316 11.9676 16.3881 11.9398 16.4778 11.8907C16.5605 11.854 16.617 11.8256 16.617 11.8256L16.7445 11.7614L16.7334 11.7399C17.3596 11.3519 18.5969 10.4316 18.9567 9.04487C19.2461 8.23722 19.1603 7.25691 18.7173 6.36804ZM14.3988 3.32659C14.973 3.04062 15.6705 3.27348 15.9564 3.84798C16.2427 4.42191 16.0098 5.11937 15.4353 5.40563C14.8611 5.69188 14.1637 5.45845 13.8777 4.88423C13.5917 4.31002 13.8252 3.61284 14.3988 3.32659ZM10.4111 6.61284C10.1249 6.03862 10.3583 5.34088 10.9325 5.05491C11.5064 4.76894 12.2039 5.00209 12.4899 5.5763C12.7758 6.15051 12.5433 6.84798 11.9688 7.13395C11.3943 7.41992 10.6974 7.18677 10.4111 6.61284ZM15.5052 9.83235C14.114 10.5261 12.616 10.3481 12.1468 9.4379L17.2119 6.91215C17.6561 7.83538 16.8967 9.13829 15.5052 9.83235Z"
      fill="currentColor"
    />
  </svg>
);

export const COMPANIES = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="stroke"
  >
    <path
      d="M16.4167 18.25V3.58333C16.4167 2.57081 15.5959 1.75 14.5833 1.75H5.41667C4.40414 1.75 3.58333 2.57081 3.58333 3.58333V18.25M16.4167 18.25L18.25 18.25M16.4167 18.25H11.8333M3.58333 18.25L1.75 18.25M3.58333 18.25H8.16667M7.25 5.41665H8.16667M7.25 9.08331H8.16667M11.8333 5.41665H12.75M11.8333 9.08331H12.75M8.16667 18.25V13.6666C8.16667 13.1604 8.57707 12.75 9.08333 12.75H10.9167C11.4229 12.75 11.8333 13.1604 11.8333 13.6666V18.25M8.16667 18.25H11.8333"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CONTACTS = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00016 9.15C7.53072 9.15 7.15016 9.53056 7.15016 10C7.15016 10.4694 7.53072 10.85 8.00016 10.85V9.15ZM10.7502 10.85C11.2196 10.85 11.6002 10.4694 11.6002 10C11.6002 9.53056 11.2196 9.15 10.7502 9.15V10.85ZM8.00016 12.8167C7.53072 12.8167 7.15016 13.1972 7.15016 13.6667C7.15016 14.1361 7.53072 14.5167 8.00016 14.5167V12.8167ZM10.7502 14.5167C11.2196 14.5167 11.6002 14.1361 11.6002 13.6667C11.6002 13.1972 11.2196 12.8167 10.7502 12.8167V14.5167ZM5.25016 9.15C4.78072 9.15 4.40016 9.53056 4.40016 10C4.40016 10.4694 4.78072 10.85 5.25016 10.85V9.15ZM5.25933 10.85C5.72877 10.85 6.10933 10.4694 6.10933 10C6.10933 9.53056 5.72877 9.15 5.25933 9.15V10.85ZM5.25016 12.8167C4.78072 12.8167 4.40016 13.1972 4.40016 13.6667C4.40016 14.1361 4.78072 14.5167 5.25016 14.5167V12.8167ZM5.25933 14.5167C5.72877 14.5167 6.10933 14.1361 6.10933 13.6667C6.10933 13.1972 5.72877 12.8167 5.25933 12.8167V14.5167ZM13.5668 5.41667V16.4167H15.2668V5.41667H13.5668ZM12.5835 17.4H3.41683V19.1H12.5835V17.4ZM2.4335 16.4167V5.41667H0.733496V16.4167H2.4335ZM3.41683 4.43333H5.25016V2.73333H3.41683V4.43333ZM10.7502 4.43333H12.5835V2.73333H10.7502V4.43333ZM3.41683 17.4C2.87375 17.4 2.4335 16.9597 2.4335 16.4167H0.733496C0.733496 17.8986 1.93487 19.1 3.41683 19.1V17.4ZM13.5668 16.4167C13.5668 16.9597 13.1266 17.4 12.5835 17.4V19.1C14.0655 19.1 15.2668 17.8986 15.2668 16.4167H13.5668ZM15.2668 5.41667C15.2668 3.9347 14.0655 2.73333 12.5835 2.73333V4.43333C13.1266 4.43333 13.5668 4.87359 13.5668 5.41667H15.2668ZM2.4335 5.41667C2.4335 4.87359 2.87375 4.43333 3.41683 4.43333V2.73333C1.93487 2.73333 0.733496 3.9347 0.733496 5.41667H2.4335ZM8.00016 10.85H10.7502V9.15H8.00016V10.85ZM8.00016 14.5167H10.7502V12.8167H8.00016V14.5167ZM7.0835 2.6H8.91683V0.9H7.0835V2.6ZM8.91683 4.56667H7.0835V6.26667H8.91683V4.56667ZM7.0835 4.56667C6.54042 4.56667 6.10016 4.12641 6.10016 3.58333H4.40016C4.40016 5.0653 5.60153 6.26667 7.0835 6.26667V4.56667ZM9.90016 3.58333C9.90016 4.12641 9.45991 4.56667 8.91683 4.56667V6.26667C10.3988 6.26667 11.6002 5.0653 11.6002 3.58333H9.90016ZM8.91683 2.6C9.45991 2.6 9.90016 3.04025 9.90016 3.58333H11.6002C11.6002 2.10137 10.3988 0.9 8.91683 0.9V2.6ZM7.0835 0.9C5.60153 0.9 4.40016 2.10137 4.40016 3.58333H6.10016C6.10016 3.04025 6.54042 2.6 7.0835 2.6V0.9ZM5.25016 10.85H5.25933V9.15H5.25016V10.85ZM5.25016 14.5167H5.25933V12.8167H5.25016V14.5167Z"
      fill="currentColor"
    />
  </svg>
);

export const AGREEMENTS = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.60104 11.399C5.26909 11.067 4.7309 11.067 4.39896 11.399C4.06701 11.7309 4.06701 12.2691 4.39896 12.601L5.60104 11.399ZM7 14L6.39896 14.601C6.73091 14.933 7.26909 14.933 7.60104 14.601L7 14ZM11.601 10.601C11.933 10.2691 11.933 9.7309 11.601 9.39896C11.2691 9.06701 10.7309 9.06701 10.399 9.39896L11.601 10.601ZM14.15 5V17H15.85V5H14.15ZM13 18.15H3V19.85H13V18.15ZM1.85 17V5H0.15V17H1.85ZM3 3.85H5V2.15H3V3.85ZM11 3.85H13V2.15H11V3.85ZM3 18.15C2.36487 18.15 1.85 17.6351 1.85 17H0.15C0.15 18.574 1.42599 19.85 3 19.85V18.15ZM14.15 17C14.15 17.6351 13.6351 18.15 13 18.15V19.85C14.574 19.85 15.85 18.574 15.85 17H14.15ZM15.85 5C15.85 3.42599 14.574 2.15 13 2.15V3.85C13.6351 3.85 14.15 4.36487 14.15 5H15.85ZM1.85 5C1.85 4.36487 2.36487 3.85 3 3.85V2.15C1.42599 2.15 0.15 3.42599 0.15 5H1.85ZM4.39896 12.601L6.39896 14.601L7.60104 13.399L5.60104 11.399L4.39896 12.601ZM7.60104 14.601L11.601 10.601L10.399 9.39896L6.39896 13.399L7.60104 14.601ZM7 1.85H9V0.15H7V1.85ZM9 4.15H7V5.85H9V4.15ZM7 4.15C6.36487 4.15 5.85 3.63513 5.85 3H4.15C4.15 4.57401 5.42599 5.85 7 5.85V4.15ZM10.15 3C10.15 3.63513 9.63513 4.15 9 4.15V5.85C10.574 5.85 11.85 4.57401 11.85 3H10.15ZM9 1.85C9.63513 1.85 10.15 2.36487 10.15 3H11.85C11.85 1.42599 10.574 0.15 9 0.15V1.85ZM7 0.15C5.42599 0.15 4.15 1.42599 4.15 3H5.85C5.85 2.36487 6.36487 1.85 7 1.85V0.15Z"
      fill="currentColor"
    />
  </svg>
);

export const NOTIFICATIONS = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height="20"
    viewBox="0 0 512 512"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g>
      <path
        d="m411 262.862v-47.862c0-69.822-46.411-129.001-110-148.33v-21.67c0-24.813-20.187-45-45-45s-45 20.187-45 45v21.67c-63.59 19.329-110 78.507-110 148.33v47.862c0 61.332-23.378 119.488-65.827 163.756-4.16 4.338-5.329 10.739-2.971 16.267s7.788 9.115 13.798 9.115h136.509c6.968 34.192 37.272 60 73.491 60 36.22 0 66.522-25.808 73.491-60h136.509c6.01 0 11.439-3.587 13.797-9.115s1.189-11.929-2.97-16.267c-42.449-44.268-65.827-102.425-65.827-163.756zm-170-217.862c0-8.271 6.729-15 15-15s15 6.729 15 15v15.728c-4.937-.476-9.94-.728-15-.728s-10.063.252-15 .728zm15 437c-19.555 0-36.228-12.541-42.42-30h84.84c-6.192 17.459-22.865 30-42.42 30zm-177.67-60c34.161-45.792 52.67-101.208 52.67-159.138v-47.862c0-68.925 56.075-125 125-125s125 56.075 125 125v47.862c0 57.93 18.509 113.346 52.671 159.138z"
        fill="currentColor"
      />
      <path
        d="m451 215c0 8.284 6.716 15 15 15s15-6.716 15-15c0-60.1-23.404-116.603-65.901-159.1-5.857-5.857-15.355-5.858-21.213 0s-5.858 15.355 0 21.213c36.831 36.831 57.114 85.8 57.114 137.887z"
        fill="currentColor"
      />
      <path
        d="m46 230c8.284 0 15-6.716 15-15 0-52.086 20.284-101.055 57.114-137.886 5.858-5.858 5.858-15.355 0-21.213-5.857-5.858-15.355-5.858-21.213 0-42.497 42.497-65.901 98.999-65.901 159.099 0 8.284 6.716 15 15 15z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const SWITCH_THEME = () => (
  <svg
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    width="16px"
    height="16px"
    fill="currentColor"
    viewBox="0 0 578.405 578.405"
  >
    <g>
      <g>
        <path
          d="M289.203,0C129.736,0,0,129.736,0,289.203C0,448.67,129.736,578.405,289.203,578.405
			c159.467,0,289.202-129.735,289.202-289.202C578.405,129.736,448.67,0,289.203,0z M28.56,289.202
			C28.56,145.48,145.481,28.56,289.203,28.56l0,0v521.286l0,0C145.485,549.846,28.56,432.925,28.56,289.202z"
        />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

export const JOBORDERS = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="stroke"
  >
    <path
      d="M18.25 12.1508C15.7023 13.1821 12.9175 13.75 10 13.75C7.08253 13.75 4.29769 13.1821 1.75 12.1508M13.6667 5.49998V3.66665C13.6667 2.65412 12.8459 1.83331 11.8333 1.83331H8.16667C7.15414 1.83331 6.33333 2.65412 6.33333 3.66665V5.49998M10 11H10.0092M3.58333 18.3333H16.4167C17.4292 18.3333 18.25 17.5125 18.25 16.5V7.33331C18.25 6.32079 17.4292 5.49998 16.4167 5.49998H3.58333C2.57081 5.49998 1.75 6.32079 1.75 7.33331V16.5C1.75 17.5125 2.57081 18.3333 3.58333 18.3333Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PIPELINE = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.88889 13.3333V20H11.1111V13.3333H15.5556L20 7.77778L15.5556 2.22222H11.1111V0H8.88889V2.22222H0L2.22222 7.77778L0 13.3333H8.88889ZM4.28889 6.95556L3.28889 4.44444H14.4889L17.1556 7.77778L14.4889 11.1111H3.28889L4.28889 8.6L4.62222 7.77778L4.28889 6.95556Z"
      fill="currentColor"
    />
  </svg>
);

export const ACCOUNTS = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 5C9 6.66 7.66 8 6 8C4.34 8 3 6.66 3 5C3 3.34 4.34 2 6 2C7.66 2 9 3.34 9 5ZM12 16H0V14C0 11.79 2.69 10 6 10C9.31 10 12 11.79 12 14V16ZM5 5C5 5.55 5.45 6 6 6C6.55 6 7 5.55 7 5C7 4.45 6.55 4 6 4C5.45 4 5 4.45 5 5ZM2 14H10C10 12.9 8.21 12 6 12C3.79 12 2 12.9 2 14ZM20 8V10H11V8H20ZM20 4V6H11V4H20ZM20 0V2H11V0H20Z"
      fill="currentColor"
    />
  </svg>
);

export const JOB_APPLICANT = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="stroke"
  >
    <path
      d="M15.5 7.25V10M15.5 10V12.75M15.5 10H18.25M15.5 10H12.75M10.9167 5.41667C10.9167 7.44171 9.27504 9.08333 7.25 9.08333C5.22496 9.08333 3.58333 7.44171 3.58333 5.41667C3.58333 3.39162 5.22496 1.75 7.25 1.75C9.27504 1.75 10.9167 3.39162 10.9167 5.41667ZM1.75 17.3333C1.75 14.2958 4.21243 11.8333 7.25 11.8333C10.2876 11.8333 12.75 14.2958 12.75 17.3333V18.25H1.75V17.3333Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CANDIDATES = () => (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="stroke"
  >
    <path
      d="M15.5835 16.3334H20.1668V14.5C20.1668 12.9812 18.9356 11.75 17.4168 11.75C16.5409 11.75 15.7605 12.1596 15.2569 12.7977M15.5835 16.3334H6.41683M15.5835 16.3334V14.5C15.5835 13.8985 15.4676 13.324 15.2569 12.7977M6.41683 16.3334H1.8335V14.5C1.8335 12.9812 3.06471 11.75 4.5835 11.75C5.45947 11.75 6.23978 12.1596 6.74339 12.7977M6.41683 16.3334V14.5C6.41683 13.8985 6.53272 13.324 6.74339 12.7977M6.74339 12.7977C7.41921 11.1093 9.07041 9.91669 11.0002 9.91669C12.9299 9.91669 14.5811 11.1093 15.2569 12.7977M13.7502 4.41669C13.7502 5.93547 12.5189 7.16669 11.0002 7.16669C9.48138 7.16669 8.25016 5.93547 8.25016 4.41669C8.25016 2.8979 9.48138 1.66669 11.0002 1.66669C12.5189 1.66669 13.7502 2.8979 13.7502 4.41669ZM19.2502 7.16669C19.2502 8.17921 18.4294 9.00002 17.4168 9.00002C16.4043 9.00002 15.5835 8.17921 15.5835 7.16669C15.5835 6.15416 16.4043 5.33335 17.4168 5.33335C18.4294 5.33335 19.2502 6.15416 19.2502 7.16669ZM6.41683 7.16669C6.41683 8.17921 5.59602 9.00002 4.5835 9.00002C3.57097 9.00002 2.75016 8.17921 2.75016 7.16669C2.75016 6.15416 3.57097 5.33335 4.5835 5.33335C5.59602 5.33335 6.41683 6.15416 6.41683 7.16669Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NOTES_SEARCH = () => (
  <svg
    width="15.52"
    height="18"
    viewBox="0 0 18 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.375 18.9688V19.4688H1.875H7V20.1562H0.9375C0.798799 20.1562 0.6875 20.045 0.6875 19.9062V1.53125C0.6875 1.39255 0.798799 1.28125 0.9375 1.28125H15.9375C16.0762 1.28125 16.1875 1.39255 16.1875 1.53125V10.2188H15.5V2.46875V1.96875H15H1.875H1.375V2.46875V18.9688ZM15.173 17.6876L14.9105 18.0348L15.2183 18.3426L17.1827 20.307L16.9008 20.589L14.9036 18.5918L14.6154 18.3036L14.2751 18.5277C13.702 18.9049 13.0189 19.125 12.2812 19.125C10.2793 19.125 8.65625 17.502 8.65625 15.5C8.65625 13.498 10.2793 11.875 12.2812 11.875C14.2832 11.875 15.9062 13.498 15.9062 15.5C15.9062 16.3222 15.6325 17.0797 15.173 17.6876ZM12.625 5.5V6H4.25V5.5H12.625ZM4.25 9.375V8.875H7.9375V9.375H4.25ZM9.15625 15.5C9.15625 17.2269 10.5543 18.625 12.2812 18.625C14.0082 18.625 15.4062 17.2269 15.4062 15.5C15.4062 13.7731 14.0082 12.375 12.2812 12.375C10.5543 12.375 9.15625 13.7731 9.15625 15.5Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const ADVANCE_SEARCH = () => (
  <svg
    width="18"
    height="18.9"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3H21M13 15L19 21L13 15ZM8 17C8.91925 17 9.82951 16.8189 10.6788 16.4672C11.5281 16.1154 12.2997 15.5998 12.9497 14.9497C13.5998 14.2997 14.1154 13.5281 14.4672 12.6788C14.8189 11.8295 15 10.9193 15 10C15 9.08075 14.8189 8.17049 14.4672 7.32122C14.1154 6.47194 13.5998 5.70026 12.9497 5.05025C12.2997 4.40024 11.5281 3.88463 10.6788 3.53284C9.82951 3.18106 8.91925 3 8 3C6.14348 3 4.36301 3.7375 3.05025 5.05025C1.7375 6.36301 1 8.14348 1 10C1 11.8565 1.7375 13.637 3.05025 14.9497C4.36301 16.2625 6.14348 17 8 17V17ZM18 0V6V0Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const RECURITED_FOLDER = () => (
  <svg
    width="20"
    height="16.71"
    viewBox="0 0 21 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.64645 14.2069L1.0605 18.7929L0.707107 18.4395L5.29305 13.8536L6.14661 13H4.9395H2V12.5H7V17.5H6.5V14.5605V13.3534L5.64645 14.2069ZM10.1464 3.35355L10.2929 3.5H10.5H19.5C19.7652 3.5 20.0196 3.60536 20.2071 3.79289C20.3946 3.98043 20.5 4.23478 20.5 4.5V10H20V4.5V4H19.5H10.0861L7.23255 1.14645L7.08611 1H6.879H1.5H1V1.5V10H0.5V1.5C0.5 1.23478 0.605357 0.980429 0.792893 0.792893C0.980429 0.605357 1.23478 0.5 1.5 0.5H6.87889C6.87893 0.5 6.87896 0.5 6.879 0.5C7.14416 0.500085 7.39843 0.605476 7.58589 0.793L7.58595 0.793053L10.1464 3.35355ZM11 18.5H15.25V19H11V18.5ZM11 15.5H20.5V16H11V15.5ZM11 12.5H20.5V13H11V12.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
  </svg>
);

export const INTERSELLER = () => (
  <svg width="20px" height="20px" viewBox="0 0 326 200" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="robot" fillRule="nonzero">
        <circle
          id="Oval"
          fill="currentColor"
          cx="133.835"
          cy="65.346"
          r="16.41"
        ></circle>
        <circle
          id="Oval"
          fill="currentColor"
          cx="219.653"
          cy="65.346"
          r="16.41"
        ></circle>
        <path
          d="M176.744,128.565 C167.824,128.565 158.462,113.553 155.608,107.769 L149.816,110.621 C151.044,113.119 162.24,135.022 176.744,135.022 C191.248,135.022 202.444,113.119 203.673,110.621 L197.881,107.771 C195.035,113.555 185.689,128.565 176.744,128.565 Z"
          id="Path"
          fill="currentColor"
        ></path>
        <path
          d="M190.464,172.416 L176.744,172.416 L163.024,172.416 C163.024,172.416 156.702,172.551 156.702,180.487 C156.702,188.423 156.702,199.856 156.702,199.856 L176.744,199.856 L196.786,199.856 C196.786,199.856 196.786,188.423 196.786,180.487 C196.786,172.551 190.464,172.416 190.464,172.416 Z"
          id="Path"
          fill="currentColor"
        ></path>
        <path
          d="M219.484,178.498 C215.386,182.351 208.168,182.81 205.718,182.653 L204.821,195.534 C205.084,195.553 205.723,195.591 206.649,195.591 C210.844,195.591 220.905,194.814 228.24,187.988 C233.286,183.294 235.953,176.607 235.953,168.649 L223.04,168.649 C223.041,173.027 221.878,176.249 219.484,178.498 Z"
          id="Path"
          fill="currentColor"
        ></path>
        <path
          d="M134.042,178.535 C131.623,176.284 130.447,173.051 130.447,168.65 L117.534,168.65 C117.534,176.608 120.201,183.295 125.246,187.989 C132.583,194.815 142.644,195.592 146.839,195.592 C147.764,195.592 148.405,195.554 148.667,195.535 L147.736,182.656 C147.652,182.661 138.924,183.074 134.042,178.535 Z"
          id="Path"
          fill="currentColor"
        ></path>
        <path
          d="M325.679,10.062 C325.679,5.654 320.46,2.081 314.021,2.081 C307.583,2.081 302.364,5.654 302.364,10.062 C302.364,13.702 305.927,16.767 310.794,17.726 L310.794,52.272 L308.723,52.272 C308.723,52.272 305.477,52.341 305.477,56.416 C305.477,57.138 305.477,57.995 305.477,58.91 C288.911,24.752 238.287,0.512 176.745,0.512 C115.122,0.512 64.442,24.815 47.944,59.044 C47.944,58.08 47.944,57.173 47.944,56.416 C47.944,52.341 44.698,52.272 44.698,52.272 L42.628,52.272 L42.628,17.726 C47.494,16.767 51.057,13.702 51.057,10.062 C51.057,5.654 45.838,2.081 39.399,2.081 C32.961,2.081 27.742,5.654 27.742,10.062 C27.742,13.702 31.305,16.767 36.172,17.726 L36.172,52.272 L34.101,52.272 C34.101,52.272 30.855,52.341 30.855,56.416 C30.855,59.104 30.855,63.599 30.855,66.356 C30.855,67.779 30.855,68.748 30.855,68.748 C30.855,71.004 30.855,97.778 30.855,108.91 L28.428,109.611 C22.002,111.714 2.273,119.766 0.814,139.708 C0.155,148.716 3.28,157.214 9.851,164.283 C20.715,175.971 39.61,182.524 63.167,182.868 L63.167,185.509 C63.167,185.509 63.231,188.527 67.019,188.527 C69.518,188.527 73.696,188.527 76.259,188.527 C77.582,188.527 78.482,188.527 78.482,188.527 C81.045,188.527 85.223,188.527 87.722,188.527 C91.51,188.527 91.575,185.509 91.575,185.509 L91.575,178.807 L91.575,175.657 C91.575,175.657 91.511,172.639 87.722,172.639 C85.223,172.639 81.045,172.639 78.482,172.639 C78.482,172.639 77.582,172.639 76.259,172.639 C73.696,172.639 69.518,172.639 67.019,172.639 C63.231,172.639 63.167,175.657 63.167,175.657 L63.167,178.564 C40.828,178.229 23.052,172.162 13.004,161.351 C7.268,155.18 4.538,147.804 5.108,140.02 C6.271,124.118 21.745,116.678 28.429,114.192 L28.429,114.18 L30.856,113.479 C30.856,113.508 30.856,113.556 30.856,113.58 C30.856,117.655 34.102,117.724 34.102,117.724 L41.311,117.724 L44.699,117.724 C44.699,117.724 47.945,117.655 47.945,113.58 C47.945,113.015 47.945,110.819 47.945,107.696 C64.443,141.925 115.123,166.228 176.746,166.228 C238.288,166.228 288.913,141.988 305.478,107.83 C305.478,110.881 305.478,113.024 305.478,113.58 C305.478,117.655 308.724,117.724 308.724,117.724 L315.933,117.724 L319.321,117.724 C319.321,117.724 322.567,117.655 322.567,113.58 C322.567,110.892 322.567,71.505 322.567,68.748 C322.567,68.748 322.567,67.78 322.567,66.356 C322.567,63.599 322.567,59.104 322.567,56.416 C322.567,52.341 319.321,52.272 319.321,52.272 L317.251,52.272 L317.251,17.726 C322.116,16.767 325.679,13.702 325.679,10.062 Z M176.744,149.011 C113.165,149.011 59.451,118.951 59.451,83.37 C59.451,47.789 113.165,17.729 176.744,17.729 C240.323,17.729 294.036,47.789 294.036,83.37 C294.036,118.951 240.323,149.011 176.744,149.011 Z"
          id="Shape"
          fill="currentColor"
        ></path>
      </g>
    </g>
  </svg>
);

export const IMPORT_CSV = () => {
  return <svg width="16" height="14" viewBox="0 0 16 14" fill="current" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.75 0.429932H1.25C1.05109 0.429932 0.860322 0.508949 0.71967 0.649602C0.579018 0.790254 0.5 0.981019 0.5 1.17993V13.1799C0.5 13.3788 0.579018 13.5696 0.71967 13.7103C0.860322 13.8509 1.05109 13.9299 1.25 13.9299H14.75C14.9489 13.9299 15.1397 13.8509 15.2803 13.7103C15.421 13.5696 15.5 13.3788 15.5 13.1799V1.17993C15.5 0.981019 15.421 0.790254 15.2803 0.649602C15.1397 0.508949 14.9489 0.429932 14.75 0.429932ZM8 10.1799C7.40326 10.1799 6.83097 9.94288 6.40901 9.52092C5.98705 9.09897 5.75 8.52667 5.75 7.92993H2V1.92993H14V7.92993H10.25C10.25 8.52667 10.0129 9.09897 9.59099 9.52092C9.16903 9.94288 8.59674 10.1799 8 10.1799ZM11 4.92993H8.75V2.67993H7.25V4.92993H5L8 8.30493L11 4.92993Z" fill="currentColor" />
  </svg>
}
//this array is used for the side bar items
export const NAV_LINKS = [
  // {
  //   title: "User Name",
  //   icon: <CANDIDATES />,
  //   url: "/settings",
  // },
  // {
  //   title: "Dashboard",
  //   icon: <DASHBOARD />,
  //   url: "/dashboard",
  // },
  // {
  //   title: "Reports",
  //   icon: <REPORTS />,
  //   url: "/reports",
  // },
  {
    title: 'Companies',
    icon: <COMPANIES />,
    url: '/companies',
  },
  {
    title: 'Contacts',
    icon: <CONTACTS />,
    url: '/contacts',
  },
  {
    title: 'Agreements',
    icon: <AGREEMENTS />,
    url: AGREEMENTS_ROUTE,
    count: '',
  },
  {
    title: 'Job Orders',
    icon: <JOBORDERS />,
    url: '/job-orders',
  },
  {
    title: 'New Applicants',
    icon: <JOBORDERS />,
    url: NEW_APPLICANTS_ROUTE,
    isChild: true,
  },
  {
    title: 'Candidate Search',
    icon: <CANDIDATES />,
    url: CANDIDATE_RECOMMENDATIONS_ROUTE,
    isChild: true,
    module: 'CANDIDATE_RECOMMENDATIONS',
  },

  {
    title: 'Job List',
    icon: <JOBORDERS />,
    url: '/job-list',
  },

  // {  
  //   title: 'Hot JobOrders',
  //   icon: <JOBORDERS />,
  //   url: '/time-to-fill',
  // },

  // {
  //   title: "Job Ads",
  //   icon: <JOBORDERS />,
  //   url: "/job-ads",
  // },

  {
    title: 'Candidates',
    icon: <CANDIDATES />,
    url: '/candidates',
    count: '',
  },
  /*
    {
      title: 'Job Applicants',
      icon: <JOB_APPLICANT />,
      url: JOB_APPLICANTS_ROUTE,
    },
    */
  // {
  //   title: "Advance Search",
  //   icon: <ADVANCE_SEARCH />,
  //   url: "/advance-search-job-candidate",
  //   count: "",
  // },
  // {
  //   title: "Notes Search",
  //   icon: <NOTES_SEARCH />,
  //   url: "/notes-es",
  //   count: "",
  // },

  // {
  //   title: "Pipeline",
  //   icon: <PIPELINE />,
  //   url: "/candidate-pipeline",
  // },
  {
    title: 'Placements',
    icon: <ACCOUNTS />,
    url: PLACEMENT_MANAGEMENT_ROUTE,
  },
  {
    title: 'Aged Invoices',
    icon: <ACCOUNTS />,
    url: INVOICE_AGING_ROUTE,
    isChild: true,
    module: 'AGED_INVOICES',
  },
  {
    title: 'Recruiter Folders',
    icon: <RECURITED_FOLDER />,
    url: RECRUITER_FOLDERS_ROUTE,
  },
  // {
  //   title: "Private Candidates",
  //   icon: <RECURITED_FOLDER />,
  //   url: "/private-candidates",
  //   roles: [ROLES.EXECUTIVE],
  // },
  // {
  //   title: "Impersonate",
  //   icon: <IMPERSONATE />,
  //   url: "/admin/persist",
  // },
  // {
  //   title: "Notifications",
  //   icon: <NOTIFICATIONS />,
  //   url: "/notifications",
  // },
  {
    title: 'Settings',
    icon: <SETTINGS />,
    url: SETTINGS_ROUTE,
  },
  {
    title: 'Import Tool',
    icon: <IMPORT_CSV />,
    url: IMPORT_CSV_ROUTE,
  },
  // {
  //   title: "Admin",
  //   icon: <ADMIN />,
  //   url: "/admin",
  //   roles: [ROLES.ADMIN],
  // },
  {
    title: 'Requests',
    icon: <REQUESTS />,
    url: REQUESTS_ROUTE,
  },
];

//for Company constans

export const COMPANY_STATUS = [
  // { label: "Draft", value: "DRAFT" },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Active Agreement', value: 'ACTIVE_AGREEMENT' },
  { label: 'Do not contact', value: 'DO_NOT_CONTACT' },
  { label: 'Prospect', value: 'PROSPECT' },
];
export const AggreementType = [
  { label: 'DIRECT HIRE', value: "DirectHire" },
  { label: 'LEGACY DIRECT HIRE', value: "LegalDirectHire" },
  { label: "LEGACY TEMP", value: "LegalContract" },
  { label: "TEMP", value: "Temp" },
  { label: "CUSTOM", value: "Custom" },
];


export const WORK_TYPE_STATUS = [
  { label: "ONSITE", value: 'On-site' },
  { label: "HYBRID", value: 'Hybrid' },
  { label: "REMOTE", value: 'Remote' },
];

export const APPLICANT_STATUS = [
  { label: 'Applied', value: 'APPLIED' },
  { label: 'Called', value: 'CALLED' },
  { label: 'Emailed', value: 'EMAILED' },
  { label: 'Keep', value: 'KEEP' },
  { label: 'Contact Later', value: 'CONTACT_LATER' },
  { label: 'Call Scheduled', value: 'CALL_SCHEDULED' },
  { label: 'Client Decline', value: 'CLIENT_DECLINE' },
  { label: 'Candidate Decline', value: 'CANDIDATE_DECLINE' },
  { label: 'Declined', value: 'DECLINED' },
];

export const ALL_APPLICANT_STATUS = [
  { label: 'Applied', value: 'APPLIED' },
  { label: 'Called', value: 'CALLED' },
  { label: 'Emailed', value: 'EMAILED' },
  { label: 'Keep', value: 'KEEP' },
  { label: 'Contact Later', value: 'CONTACT_LATER' },
  { label: 'Call Scheduled', value: 'CALL_SCHEDULED' },
  // { label: "Interviewed", value: "INTERVIEWED" },
  // { label: "Submitted", value: "SUBMITTED" },
  // { label: "Referenced", value: "REFERENCED" },
  // { label: "Offered", value: "OFFERED" },
  // { label: "Placed", value: "PLACED" },
  { label: 'Client Decline', value: 'CLIENT_DECLINE' },
  { label: 'Declined', value: 'DECLINED' },
];

export const APPLICANT_STATUS_RESULTS = [
  { label: 'Current Keep List', value: 'IN_KEEP_LIST' },
  { label: 'Current Excluded List', value: 'IN_EXCLUDED_LIST' },
];

export const invoiceStatus = [
  { value: "INVOICE_SENT", label: "Invoice Sent" },
  { value: "PAYMENT_RECEIVED", label: "Payment Received" },
  { value: "REMINDER_SENT", label: "Reminder Sent" }
]

export const IMPORT_SOURCE = [
  { value: "SEAM_LESS", label: "Seamless.ai" },
  { value: "ZOOM_INFO", label: "ZoomInfo" },
]

export const ADMIN_IMPORT_SOURCE = [
  { value: "SEAM_LESS_ADMIN", label: "Seamless" },
  { value: "OUTREACH", label: "Outreach Sequence Report" },
]

export const TEMP_BILLING_IMPORTS_OPTIONS = [
  { value: "RECRUITER_PROFIT_SUMMARY", label: "Recruiter Profit Summary" },
  { value: "A_R_AGING_BY_RECRUITER", label: "A/R Aging by Recruiter" },
  { value: "RECRUITER_AGENCY_WEEKLY_ACTIVITY", label: "Recruiter Agency Weekly Activity" },
]

// The listing row's reportType holds the enum VALUE (the option label above),
// not the option value — compare against this constant with ===.
export const WEEKLY_ACTIVITY_REPORT_TYPE = "Recruiter Agency Weekly Activity"

export const CompanySize = [
  { label: '0-25', value: '0-25' },
  { label: '26-50', value: '26-50' },
  { label: '51-100', value: '51-100' },
  { label: '101-200', value: '101-200' },
  { label: '201-500', value: '201-500' },
  { label: '501+', value: '501+' },
];

export const CandidateSource = [
  // kan-110: set by the job-order Bulk Add intake; the "(Claude Parsed)" variant
  // marks candidates whose résumé Sovren could not parse and our own parser did.
  { label: 'Bulk Add', value: 'Bulk Add' },
  { label: 'Bulk Add (Claude Parsed)', value: 'Bulk Add (Claude Parsed)' },
  { label: 'Career Builder', value: 'Career Builder' },
  { label: 'Current Client', value: 'Current Client' },
  { label: 'Direct Email', value: 'Direct Email' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Indeed Application', value: 'Indeed Application' },
  { label: 'Indeed Search', value: 'Indeed Search' },
  { label: 'Instagram', value: 'Instagram' },
  { label: 'LinkedIn Application', value: 'LinkedIn Application' },
  { label: 'LinkedIn Search', value: 'LinkedIn Search' },
  { label: 'Pin', value: 'Pin' },
  { label: 'Recruiter', value: 'Recruiter' },
  { label: 'Referral', value: 'Referral' },
  { label: 'Seamless.ai', value: 'Seamless.ai' },
  { label: 'Southland Application', value: 'Southland Application' },
  { label: 'ZipRecruiter Application', value: 'ZipRecruiter Application' },
  { label: 'ZipRecruiter Search', value: 'ZipRecruiter Search' },
  { label: 'ZoomInfo', value: 'ZoomInfo' },


];
export const CompanySource = [
  { label: 'Career Builder', value: 'Career Builder' },
  { label: 'CraigList', value: 'CraigList' },
  { label: 'Current Client', value: 'Current Client' },
  { label: 'Direct Email', value: 'Direct Email' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Indeed Application', value: 'Indeed Application' },
  { label: 'Indeed Search', value: 'Indeed Search' },
  { label: 'Instagram', value: 'Instagram' },
  { label: 'LinkedIn Application', value: 'LinkedIn Application' },
  { label: 'LinkedIn Search', value: 'LinkedIn Search' },
  { label: 'Pin', value: 'Pin' },
  { label: 'Recruiter', value: 'Recruiter' },
  { label: 'Referral', value: 'Referral' },
  { label: 'Seamless.ai', value: 'Seamless.ai' },
  { label: 'ZipRecruiter Application', value: 'ZipRecruiter Application' },
  { label: 'ZipRecruiter Search', value: 'ZipRecruiter Search' },
  { label: 'ZoomInfo', value: 'ZoomInfo' },


];

// contact type

// export const contactType = [
//   { label: "Main", value: "MAIN" },
//   { label: "Billing", value: "BILLING" },
//   { label: "ReportTo", value: "REPORTTO" },
// ];

export const contactStatus = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Do Not Contact', value: 'DO_NOT_CONTACT' },
  { label: 'Separated', value: 'SEPARATED' }
];

export const ContactPhoneType = [
  { label: 'Mobile', value: 'MOBILE' },
  { label: 'Work', value: 'WORK' },
  { label: 'Fax', value: 'FAX' },
  { label: 'Home', value: 'HOME' },
];
export const AgreementStatus = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'CLIENT_PREVIEW', label: 'Client Preview' },
  { value: 'AWAITING_MANAGER_APPROVAL', label: 'Awaiting manager approval' },
  { value: 'MANAGER_REJECTED', label: 'Manager rejected' },
  {
    value: 'AWAITING_EXECUTIVE_APPROVAL',
    label: 'Awaiting executive approval',
  },
  { value: 'EXECUTIVE_APPROVED', label: 'Executive approved' },
  { value: 'EXECUTIVE_REJECTED', label: 'Executive rejected' },
  { value: 'OUT_FOR_SIGNATURE', label: 'Out for signature' },
  { value: 'SIGNED', label: 'Signed' },
  { value: 'MY_AGREEMENTS', label: 'My Agreements' },
  { value: 'MY_PENDING_AGREEMENTS', label: 'Pending Actions' },
  { value: 'MY_REJECTED_AGREEMENTS', label: 'Rejected Agreements' },
  { value: 'UNDELIVERABLE', label: 'Undeliverable' },
];

export const agreementType = ['DIRECT_HIRE', 'TEMP', 'CUSTOM'];

export const LEGAL_AGREEMENT_STATUS = [
  { value: 'LEGAL_DIRECT_HIRE', label: 'Legal Direct Hire' },
  {
    value: 'LEGAL_CONTRACT',
    label: 'Legal Contract',
  },
];

export const legalAgreementType = ['LEGAL_DIRECT_HIRE', 'LEGAL_CONTRACT'];

export const JobOrderStatusInApplicant = [
  { label: 'Draft', value: 'DRAFT' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Close', value: 'CLOSE' },
];

export const BILLING_CREDIT_START_RANGE = [
  { label: '$0', value: '$0' },
  { label: '$150,001', value: '$150,001' },
  { label: '$200,001', value: '$200,001' },
  { label: '$250,001', value: '$250,001' },
  { label: '$300,001', value: '$300,001' },
  { label: '$350,001', value: '$350,001' },
  { label: '$400,001', value: '$400,001' },
  { label: '$450,001', value: '$450,001' },
  { label: '$500,001', value: '$500,001' },
  { label: '$750,001', value: '$750,001' },
  { label: '$1,000,001', value: '$1,000,001' }
]

export const BILLING_CREDIT_END_RANGE = [
  { label: '$150,000', value: '$150,000' },
  { label: '$200,000', value: '$200,000' },
  { label: '$250,000', value: '$250,000' },
  { label: '$300,000', value: '$300,000' },
  { label: '$350,000', value: '$350,000' },
  { label: '$400,000', value: '$400,000' },
  { label: '$450,000', value: '$450,000' },
  { label: '$500,000', value: '$500,000' },
  { label: '$750,000', value: '$750,000' },
  { label: '$1,000,000', value: '$1,000,000' },
  { label: '+', value: '+' },
]


export const JobOrderStatus = [
  ...JobOrderStatusInApplicant,
  { label: 'Filled By Us', value: 'FILLED_BY_US' },
  { label: 'Filled By Client', value: 'FILLED_BY_CLIENT' },
  { label: 'Lost to Competitor', value: 'LOST_TO_COMPETITOR' },
  { label: 'Cancelled', value: 'CANCELLED' },
  { label: 'Hold', value: 'HOLD' },
  { label: 'My Job Order', value: 'MY_JOB_ORDERS' },
  { label: 'Duplicated Job', value: 'DUPLICATED_JOB' },
];



export const JobOrderBulkActions = [
  { label: 'Post Job', value: 'POST' },
  { label: 'Unpost Job', value: 'UNPOST' },
  { label: 'Mark as Hot Job', value: 'HOT' },
  { label: 'No Longer Hot Job', value: 'UNHOT' },
];

// Kept in alphabetical order by label - this renders directly as the status
// dropdown on the Temp/Custom update-agreement page.
export const TEMP_AGREEMENT_STATUS: SelectOptionsType[] = [
  { value: 'CLIENT_PREVIEW', label: 'Client preview' },
  { value: 'OUT_FOR_SIGNATURE', label: 'Out for signature' },
  { value: 'SIGNED', label: 'Signed' },
  { value: 'VOIDED', label: 'Voided' },
];

export const commissionPercentage = [
  { label: '20 %', value: 20 },
  { label: '21 %', value: 21 },
  { label: '22 %', value: 22 },
  { label: '23 %', value: 23 },
  { label: '24 %', value: 24 },
  { label: '25 %', value: 25 },
  { label: '26 %', value: 26 },
  { label: '27 %', value: 27 },
  { label: '28 %', value: 28 },
  { label: '29 %', value: 29 },
  { label: '30 %', value: 30 },
  { label: '31 %', value: 31 },
  { label: '32 %', value: 32 },
  { label: '33 %', value: 33 },
  { label: '34 %', value: 34 },
  { label: '35 %', value: 35 },
  { label: '36 %', value: 36 },
  { label: '37 %', value: 37 },
  { label: '38 %', value: 38 },
  { label: '39 %', value: 39 },
  { label: '40 %', value: 40 },
];

export const ZERO_TO_HUNDRED = /^(?:100(?:[.,]00?)?|\d?\d(?:[.,]\d\d?)?)$/;

export const replacementDays = [
  { label: '30 days', value: 30 },
  { label: '60 days', value: 60 },
  { label: '90 days', value: 90 },
];

export const payableDays = [
  { label: '15 days', value: 15 },
  { label: '30 days', value: 30 },
];

export const MergeCompanyType = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Merged', value: 'MERGED' },
  { label: 'Error', value: 'ERROR' },
];

export const MergeCandidateType = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Merged', value: 'MERGED' },
  { label: 'Error', value: 'ERROR' },
];

export const RateType = [
  { label: 'Annual', value: 'ANNUAL' },
  { label: 'Hourly', value: 'HOURLY' },
];

export const FeeType = [
  { label: 'Percentage', value: 'PERCENTAGE' },
  { label: 'Fixed Fee', value: 'FIXED_FEE' },
];

export const RecruitingLevelStatus = [
  { label: 'Private', value: 'PRIVATE' },
  { label: 'Team', value: 'TEAM' },
  { label: 'Open', value: 'OPEN' },
];

export const Education = [
  { label: 'Inter', value: 'Inter' },
  { label: 'Graduation', value: 'Graduation' },
  { label: 'Master', value: 'Master' },
];

export const WorkType = [
  { label: 'Direct Hire', value: 'DIRECT_HIRE' },
  { label: 'Temp', value: 'TEMP' },
];
export const workplaceTypes = [
  { label: 'On-site', value: 'ONSITE' },
  { label: 'Hybrid', value: 'HYBRID' },
  { label: 'Remote', value: 'REMOTE' },
];

export const IdealWorkType = [
  { label: 'Full Time', value: 'FULLTIME' },
  { label: 'Temp', value: 'TEMP' },
];

export const CandidateWriteUp = [
  { label: 'Initial Call', value: 'INITIAL_CALL' },
  { label: 'Web Meeting', value: 'MEETING' },
  { label: 'Complete Writeup', value: 'SUMMARY' },
];

export const COUNTRY_STATES_PROVINCE = (country) => {
  if (country === 'US') {
    return [
      { label: 'Alabama', value: 'AL' },
      { label: 'Alaska', value: 'AK' },
      { label: 'American Samoa', value: 'AS' },
      { label: 'Arizona', value: 'AZ' },
      { label: 'Arkansas', value: 'AR' },
      { label: 'California', value: 'CA' },
      { label: 'Colorado', value: 'CO' },
      { label: 'Connecticut', value: 'CT' },
      { label: 'Delaware', value: 'DE' },
      { label: 'District of Columbia', value: 'DC' },
      { label: 'Federated States of Micronesia', value: 'FM' },
      { label: 'Florida', value: 'FL' },
      { label: 'Georgia', value: 'GA' },
      { label: 'Guam', value: 'GU' },
      { label: 'Hawaii', value: 'HI' },
      { label: 'Idaho', value: 'ID' },
      { label: 'Illinois', value: 'IL' },
      { label: 'Indiana', value: 'IN' },
      { label: 'Iowa', value: 'IA' },
      { label: 'Kansas', value: 'KS' },
      { label: 'Kentucky', value: 'KY' },
      { label: 'Louisiana', value: 'LA' },
      { label: 'Maine', value: 'ME' },
      { label: 'Marshall Islands', value: 'MH' },
      { label: 'Maryland', value: 'MD' },
      { label: 'Massachusetts', value: 'MA' },
      { label: 'Michigan', value: 'MI' },
      { label: 'Minnesota', value: 'MN' },
      { label: 'Mississippi', value: 'MS' },
      { label: 'Missouri', value: 'MO' },
      { label: 'Montana', value: 'MT' },
      { label: 'Nebraska', value: 'NE' },
      { label: 'Nevada', value: 'NV' },
      { label: 'New Hampshire', value: 'NH' },
      { label: 'New Jersey', value: 'NJ' },
      { label: 'New Mexico', value: 'NM' },
      { label: 'New York', value: 'NY' },
      { label: 'North Carolina', value: 'NC' },
      { label: 'North Dakota', value: 'ND' },
      { label: 'Northern Mariana Islands', value: 'MP' },
      { label: 'Ohio', value: 'OH' },
      { label: 'Oklahoma', value: 'OK' },
      { label: 'Oregon', value: 'OR' },
      { label: 'Palau', value: 'PW' },
      { label: 'Pennsylvania', value: 'PA' },
      { label: 'Puerto Rico', value: 'PR' },
      { label: 'Rhode Island', value: 'RI' },
      { label: 'South Carolina', value: 'SC' },
      { label: 'South Dakota', value: 'SD' },
      { label: 'Tennessee', value: 'TN' },
      { label: 'Texas', value: 'TX' },
      { label: 'Utah', value: 'UT' },
      { label: 'Vermont', value: 'VT' },
      { label: 'Virgin Island', value: 'VI' },
      { label: 'Virginia', value: 'VA' },
      { label: 'Washington', value: 'WA' },
      { label: 'West Virginia', value: 'WV' },
      { label: 'Wisconsin', value: 'WI' },
      { label: 'Wyoming', value: 'WY' },
    ];
  } else if (country === 'CA') {
    return [
      { label: 'Alberta', value: 'AB' },
      { label: 'British Columbia', value: 'BC	' },
      { label: 'Manitoba', value: 'MB' },
      { label: 'New Brunswick', value: 'NB' },
      { label: 'Newfoundland and Labrador', value: 'NL' },
      { label: 'Nova Scotia', value: 'NS' },
      { label: 'Ontario', value: 'ON' },
      { label: 'Prince Edward Island', value: 'PE' },
      { label: 'Quebec', value: 'QC' },
      { label: 'Saskatchewan', value: 'SK' },
    ];
  } else if (country === 'MX') {
    return [
      { label: 'Aguascalientes', value: 'AG' },
      { label: 'Baja California', value: 'BC' },
      { label: 'Baja California Sur', value: 'BS' },
      { label: 'Campeche', value: 'CM' },
      { label: 'Chiapas', value: 'CS' },
      { label: 'Chihuahua', value: 'CH' },
      { label: 'Coahuila', value: 'CO' },
      { label: 'Colima', value: 'CL' },
      { label: 'Durango', value: 'DG' },
      { label: 'Guanajuato', value: 'GT' },
      { label: 'Guerrero', value: 'GR' },
      { label: 'Hidalgo', value: 'HG' },
      { label: 'Jalisco', value: 'JA' },
      { label: 'México', value: 'EM' },
      { label: 'Mexico City', value: 'DF' },
      { label: 'Michoacán', value: 'MI' },
      { label: 'Morelos', value: 'MO' },
      { label: 'Nayarit', value: 'NA' },
      { label: 'Nuevo León', value: 'NL' },
      { label: 'Oaxaca', value: 'OA' },
      { label: 'Puebla', value: 'PU' },
      { label: 'Querétaro', value: 'QT' },
      { label: 'Quintana Roo', value: 'QR' },
      { label: 'San Luis Potosí', value: 'SL' },
      { label: 'Sinaloa', value: 'SI' },
      { label: 'Sonora', value: 'SO' },
      { label: 'Tabasco', value: 'TB' },
      { label: 'Tamaulipas', value: 'TM' },
      { label: 'Tlaxcala', value: 'TL' },
      { label: 'Veracruz', value: 'VE' },
      { label: 'Yucatán', value: 'YU' },
      { label: 'Zacatecas', value: 'ZA' },
    ];
  } else {
    return [];
  }
};

export const states_candidate_constant = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

export const candidateTitle = [
  { label: 'Mr', value: 'MR' },
  { label: 'Miss', value: 'MISS' },
  { label: 'Mrs', value: 'MRS' },
  { label: 'Ms', value: 'MS' },
  { label: 'Dr', value: 'DR' },
];

export const cities = [
  'Aberdeen',
  'Abilene',
  'Akron',
  'Albany',
  'Albuquerque',
  'Alexandria',
  'Allentown',
  'Amarillo',
  'Anaheim',
  'Anchorage',
  'Ann Arbor',
  'Antioch',
  'Apple Valley',
  'Appleton',
  'Arlington',
  'Arvada',
  'Asheville',
  'Athens',
  'Atlanta',
  'Atlantic City',
  'Augusta',
  'Aurora',
  'Austin',
  'Bakersfield',
  'Baltimore',
  'Barnstable',
  'Baton Rouge',
  'Beaumont',
  'Bel Air',
  'Bellevue',
  'Berkeley',
  'Bethlehem',
  'Billings',
  'Birmingham',
  'Bloomington',
  'Boise',
  'Boise City',
  'Bonita Springs',
  'Boston',
  'Boulder',
  'Bradenton',
  'Bremerton',
  'Bridgeport',
  'Brighton',
  'Brownsville',
  'Bryan',
  'Buffalo',
  'Burbank',
  'Burlington',
  'Cambridge',
  'Canton',
  'Cape Coral',
  'Carrollton',
  'Cary',
  'Cathedral City',
  'Cedar Rapids',
  'Champaign',
  'Chandler',
  'Charleston',
  'Charlotte',
  'Chattanooga',
  'Chesapeake',
  'Chicago',
  'Chula Vista',
  'Cincinnati',
  'Clarke County',
  'Clarksville',
  'Clearwater',
  'Cleveland',
  'College Station',
  'Colorado Springs',
  'Columbia',
  'Columbus',
  'Concord',
  'Coral Springs',
  'Corona',
  'Corpus Christi',
  'Costa Mesa',
  'Dallas',
  'Daly City',
  'Danbury',
  'Davenport',
  'Davidson County',
  'Dayton',
  'Daytona Beach',
  'Deltona',
  'Denton',
  'Denver',
  'Des Moines',
  'Detroit',
  'Downey',
  'Duluth',
  'Durham',
  'El Monte',
  'El Paso',
  'Elizabeth',
  'Elk Grove',
  'Elkhart',
  'Erie',
  'Escondido',
  'Eugene',
  'Evansville',
  'Fairfield',
  'Fargo',
  'Fayetteville',
  'Fitchburg',
  'Flint',
  'Fontana',
  'Fort Collins',
  'Fort Lauderdale',
  'Fort Smith',
  'Fort Walton Beach',
  'Fort Wayne',
  'Fort Worth',
  'Frederick',
  'Fremont',
  'Fresno',
  'Fullerton',
  'Gainesville',
  'Garden Grove',
  'Garland',
  'Gastonia',
  'Gilbert',
  'Glendale',
  'Grand Prairie',
  'Grand Rapids',
  'Grayslake',
  'Green Bay',
  'GreenBay',
  'Greensboro',
  'Greenville',
  'Gulfport-Biloxi',
  'Hagerstown',
  'Hampton',
  'Harlingen',
  'Harrisburg',
  'Hartford',
  'Havre de Grace',
  'Hayward',
  'Hemet',
  'Henderson',
  'Hesperia',
  'Hialeah',
  'Hickory',
  'High Point',
  'Hollywood',
  'Honolulu',
  'Houma',
  'Houston',
  'Howell',
  'Huntington',
  'Huntington Beach',
  'Huntsville',
  'Independence',
  'Indianapolis',
  'Inglewood',
  'Irvine',
  'Irving',
  'Jackson',
  'Jacksonville',
  'Jefferson',
  'Jersey City',
  'Johnson City',
  'Joliet',
  'Kailua',
  'Kalamazoo',
  'Kaneohe',
  'Kansas City',
  'Kennewick',
  'Kenosha',
  'Killeen',
  'Kissimmee',
  'Knoxville',
  'Lacey',
  'Lafayette',
  'Lake Charles',
  'Lakeland',
  'Lakewood',
  'Lancaster',
  'Lansing',
  'Laredo',
  'Las Cruces',
  'Las Vegas',
  'Layton',
  'Leominster',
  'Lewisville',
  'Lexington',
  'Lincoln',
  'Little Rock',
  'Long Beach',
  'Lorain',
  'Los Angeles',
  'Louisville',
  'Lowell',
  'Lubbock',
  'Macon',
  'Madison',
  'Manchester',
  'Marina',
  'Marysville',
  'McAllen',
  'McHenry',
  'Medford',
  'Melbourne',
  'Memphis',
  'Merced',
  'Mesa',
  'Mesquite',
  'Miami',
  'Milwaukee',
  'Minneapolis',
  'Miramar',
  'Mission Viejo',
  'Mobile',
  'Modesto',
  'Monroe',
  'Monterey',
  'Montgomery',
  'Moreno Valley',
  'Murfreesboro',
  'Murrieta',
  'Muskegon',
  'Myrtle Beach',
  'Naperville',
  'Naples',
  'Nashua',
  'Nashville',
  'New Bedford',
  'New Haven',
  'New London',
  'New Orleans',
  'New York',
  'New York City',
  'Newark',
  'Newburgh',
  'Newport News',
  'Norfolk',
  'Normal',
  'Norman',
  'North Charleston',
  'North Las Vegas',
  'North Port',
  'Norwalk',
  'Norwich',
  'Oakland',
  'Ocala',
  'Oceanside',
  'Odessa',
  'Ogden',
  'Oklahoma City',
  'Olathe',
  'Olympia',
  'Omaha',
  'Ontario',
  'Orange',
  'Orem',
  'Orlando',
  'Overland Park',
  'Oxnard',
  'Palm Bay',
  'Palm Springs',
  'Palmdale',
  'Panama City',
  'Pasadena',
  'Paterson',
  'Pembroke Pines',
  'Pensacola',
  'Peoria',
  'Philadelphia',
  'Phoenix',
  'Pittsburgh',
  'Plano',
  'Pomona',
  'Pompano Beach',
  'Port Arthur',
  'Port Orange',
  'Port Saint Lucie',
  'Port St. Lucie',
  'Portland',
  'Portsmouth',
  'Poughkeepsie',
  'Providence',
  'Provo',
  'Pueblo',
  'Punta Gorda',
  'Racine',
  'Raleigh',
  'Rancho Cucamonga',
  'Reading',
  'Redding',
  'Reno',
  'Richland',
  'Richmond',
  'Richmond County',
  'Riverside',
  'Roanoke',
  'Rochester',
  'Rockford',
  'Roseville',
  'Round Lake Beach',
  'Sacramento',
  'Saginaw',
  'Saint Louis',
  'Saint Paul',
  'Saint Petersburg',
  'Salem',
  'Salinas',
  'Salt Lake City',
  'San Antonio',
  'San Bernardino',
  'San Buenaventura',
  'San Diego',
  'San Francisco',
  'San Jose',
  'Santa Ana',
  'Santa Barbara',
  'Santa Clara',
  'Santa Clarita',
  'Santa Cruz',
  'Santa Maria',
  'Santa Rosa',
  'Sarasota',
  'Savannah',
  'Scottsdale',
  'Scranton',
  'Seaside',
  'Seattle',
  'Sebastian',
  'Shreveport',
  'Simi Valley',
  'Sioux City',
  'Sioux Falls',
  'South Bend',
  'South Lyon',
  'Spartanburg',
  'Spokane',
  'Springdale',
  'Springfield',
  'St. Louis',
  'St. Paul',
  'St. Petersburg',
  'Stamford',
  'Sterling Heights',
  'Stockton',
  'Sunnyvale',
  'Syracuse',
  'Tacoma',
  'Tallahassee',
  'Tampa',
  'Temecula',
  'Tempe',
  'Thornton',
  'Thousand Oaks',
  'Toledo',
  'Topeka',
  'Torrance',
  'Trenton',
  'Tucson',
  'Tulsa',
  'Tuscaloosa',
  'Tustin',
  'Tyler',
  'Utica',
  'Vallejo',
  'Vancouver',
  'Vero Beach',
  'Victorville',
  'Virginia Beach',
  'Visalia',
  'Waco',
  'Warren',
  'Washington',
  'Waterbury',
  'Waterloo',
  'West Covina',
  'West Valley City',
  'Westminster',
  'Wichita',
  'Wilmington',
  'Winston',
  'Winter Haven',
  'Worcester',
  'Yakima',
  'Yonkers',
  'York',
  'Youngstown',
];

export const MONTHS_IN_YEAR = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"]
export const CSV_IMPORTS_HEADER = {
  SEAM_LESS: ['First Name', 'Last Name', 'Title', 'Company Name - Cleaned', 'Website', 'Contact LI Profile URL', 'Email 1', 'Contact Phone 1', 'Company City', 'Company State Abbr', 'Company Post Code', 'Company Website Domain', 'Company LI Profile Url'],
  ZOOM_INFO: ['ZoomInfo Contact ID', 'Last Name', 'First Name', 'Middle Name', 'Salutation', 'Suffix', 'Job Title', 'Management Level', 'Job Start Date', 'Job Function', 'Department', 'Company Division Name', 'Direct Phone Number', 'Email Address', 'Email Domain', 'Mobile phone', 'Highest Level of Education', 'Contact Accuracy Score', 'Contact Accuracy Grade', 'ZoomInfo Contact Profile URL', 'LinkedIn Contact Profile URL', 'Notice Provided Date', 'Person Street', 'Person City', 'Person State', 'Person Zip Code', 'Country', 'ZoomInfo Company ID', 'Company Name', 'Website', 'Founded Year', 'Company HQ Phone', 'Fax', 'Ticker', 'Revenue (in 000s USD)', 'Revenue Range (in USD)', 'Employees', 'Employee Range', 'SIC Code 1', 'SIC Code 2', 'SIC Codes', 'NAICS Code 1', 'NAICS Code 2', 'NAICS Codes', 'Primary Industry', 'Primary Sub-Industry', 'All Industries', 'All Sub-Industries', 'Industry Hierarchical Category', 'Secondary Industry Hierarchical Category', 'Alexa Rank', 'ZoomInfo Company Profile URL', 'LinkedIn Company Profile URL', 'Facebook Company Profile URL', 'Twitter Company Profile URL', 'Ownership Type', 'Business Model', 'Certified Active Company', 'Certification Date', 'Total Funding Amount (in 000s USD)', 'Recent Funding Amount (in 000s USD)', 'Recent Funding Round', 'Recent Funding Date', 'Recent Investors', 'All Investors', 'Company Street Address', 'Company City', 'Company State', 'Company Zip Code', 'Company Country', 'Full Address', 'Number of Locations', 'Query Name\r'],
  SEAM_LESS_ADMIN: ['User Activity Report', '03/20/2024 05:56:42 PM', 'Last 12 Week', '', '', '', '', '', '', 'Week Ending'],
  OUTREACH: ["Sequence name", "Sequence ID", "Owner ID", "Owner name", "Created at", "Last used at", "Prospects added", "Open rate", "Click rate", "Reply rate"],
  CONTACT_IMPORT: ['Company Name', 'Company Domain', 'Street Address', 'City', 'State', 'Country', 'LinkedIn Profile URL', 'First Name', 'Last Name', 'Job Title', 'Email', 'Phone']
}

export const CSV_IMPORTS_SAMPLE_FILES = {
  SEAM_LESS: "https://storage.googleapis.com/ats-realrepp-stage-private/attachments/1707986339498-MyContacts_export_joemorrell@seamlessexpert_2024-01-29-17-09-33_cleaned.csv",
  SEAM_LESS_PROD: "https://storage.googleapis.com/ats-realrepp-prod-private/documents/1754302547470-SEAM_LESS.csv",
  ZOOM_INFO: "https://storage.googleapis.com/ats-realrepp-stage-private/attachments/1715322630264-ZOOM_INFO.csv",
  ZOOM_INFO_PROD: "https://storage.googleapis.com/ats-realrepp-prod-private/documents/1754302513778-ZOOM_INFO.csv",
  CONTACT_IMPORT: "https://storage.googleapis.com/ats-realrepp-stage-private/attachments/1747740017177-contact_import.xlsx",
  CONTACT_IMPORT_PROD: "https://storage.googleapis.com/ats-realrepp-prod-private/documents/1754300933753-contact_import.xlsx"

}

export const convertToLowerCase = cities.map((item) => item.toLowerCase());

export const allEmployee = [
  {
    execName: 'Johnny Renaudo',
    teamName: '',
    managerName: '',
    teamMember: '',
    reportsTo: '',
  },
  {
    execName: 'Kendra Lester',
    teamName: '',
    managerName: '',
    teamMember: '',
    reportsTo: '',
  },
  {
    execName: '',
    teamName: 'Team Paige',
    managerName: 'Paige Embleton',
    teamMember: '',
    reportsTo: 'Kendra Lester',
  },
  {
    execName: '',
    teamName: '',
    managerName: '',
    teamMember: 'Megan Herrera',
    reportsTo: 'Paige Embleton',
  },
  {
    execName: '',
    teamName: '',
    managerName: '',
    teamMember: 'Callum Salter',
    reportsTo: 'Paige Embleton',
  },
  {
    execName: '',
    teamName: 'Team Dylan',
    managerName: 'Dylan Jimenez',
    teamMember: '',
    reportsTo: 'Kendra Lester',
  },
  {
    execName: '',
    teamName: '',
    managerName: '',
    teamMember: 'Linze Nichols',
    reportsTo: '',
  },
  {
    execName: '',
    teamName: '',
    managerName: '',
    teamMember: 'Shannel Goettman',
    reportsTo: 'Dylan Jimenez',
  },
  {
    execName: '',
    teamName: 'Team Megan',
    managerName: 'Megan Scott',
    teamMember: '',
    reportsTo: 'Paige Embleton',
  },
  {
    execName: '',
    teamName: '',
    managerName: '',
    teamMember: 'Haley Paek',
    reportsTo: 'Tiffani Randolph',
  },
  {
    execName: '',
    teamName: '',
    managerName: '',
    teamMember: 'Tiffani Randolph',
    reportsTo: 'Megan Scott',
  },
  {
    execName: '',
    teamName: '',
    managerName: '',
    teamMember: 'Andy Galuska',
    reportsTo: 'Megan Scott',
  },
];

export const allAdmin = [
  {
    admin: 'Johnny Renaudo',
    reportsTo: '',
  },
  {
    admin: 'Kendra Lester',
    reportsTo: '',
  },
  {
    admin: 'Peter Tan',
    reportsTo: 'Johnny Renaudo',
  },
];
export const CandidateEducationList = [
  { label: 'High School Diploma/GED', value: 'High_School_Diploma_GED' },
  { label: 'Associates Degree', value: 'Associates_Degree' },
  { label: 'Bachelors Degree', value: 'Bachelors_Degree' },
  { label: 'Masters Degree', value: 'Masters_Degree' },
  { label: 'Doctors Degree', value: 'Doctors_Degree' },
];

export const sequenceOptions = [
  { label: 'Business Development', value: 'BUSINESS_DEVELOPMENT' },
  { label: 'Recruitment', value: 'RECRUITING' },
];
export const CategoryList = [
  { label: 'Category1', value: 'CATEGORY1' },
  { label: 'Category2', value: 'CATEGORY2' },
  { label: 'Category3', value: 'CATEGORY3' },
  { label: 'Category4', value: 'CATEGORY4' },
  { label: 'Category5', value: 'CATEGORY5' },
];

export const intersellerContactsFilters = [
  { label: 'On Going', value: 'ongoing' },
  { label: 'Paused', value: 'paused' },
  { label: 'Messaged', value: 'messaged' },
  { label: 'Created', value: 'created' },
  { label: 'Customized', value: 'customized' },
  { label: 'Step', value: 'step' },
  { label: 'Opened', value: 'opened' },
  { label: 'Replied', value: 'replied' },
  { label: 'Sentiment', value: 'sentiment' },
  { label: 'Booked', value: 'booked' },
  { label: 'Unsubscribed', value: 'unsubscribed' },
  { label: 'Bounced', value: 'bounced' },
  { label: 'All Errors', value: 'all_errors' },
];

export const contactsMeetingsAddedToday = [
  { label: 'Contacts Added', value: 'created' },
  { label: 'Meetings Booked', value: 'booked' },
];

export const lookupEmailOptions = [
  {
    label: "Don't lookup any contacts missing emails & skip them",
    value: 'DONT_LOOKUP',
  },
  {
    label:
      'Find work emails for contacts missing emails (slow import & uses lookup credits)',
    value: 'WORK',
  },
  {
    label:
      'Find personal emails for contacts missing emails (slow import & uses lookup credits)',
    value: 'PERSONAL',
  },
];

export const csvMapFields = [
  { label: 'name', value: 0 },
  { label: 'first_name', value: 1 },
  { label: 'last_name', value: 2 },
  { label: 'company', value: 3 },
  { label: 'email', value: 4 },
  { label: 'title', value: 5 },
  { label: 'location', value: 6 },
  { label: 'city', value: 7 },
  { label: 'state', value: 8 },
  { label: 'country', value: 9 },
  { label: 'phone_number', value: 10 },
  { label: 'source_url', value: 11 },
  { label: 'profile_url', value: 12 },
  { label: 'url', value: 13 },
  { label: 'created_at', value: 14 },
  { label: 'step', value: 15 },
  { label: 'first_messaged_at', value: 16 },
  { label: 'last_messaged_at', value: 17 },
  { label: 'bounced', value: 18 },
  { label: 'bounced_reason', value: 19 },
  { label: 'unsubscribed', value: 20 },
  { label: 'viewed_at', value: 21 },
  { label: 'visited_at', value: 22 },
  { label: 'view_count', value: 23 },
  { label: 'visit_count', value: 24 },
  { label: 'delay_until', value: 25 },
  { label: 'replied_at', value: 26 },
  { label: 'sentiment', value: 27 },
  { label: 'finished', value: 28 },
  { label: 'state', value: 29 },
  { label: 'validity', value: 30 },
  { label: 'linkedin_id', value: 31 },
  { label: 'gender', value: 32 },
  { label: 'age', value: 33 },
  // When we get fields of a specific compaign, we recieve the following
  // Start
  { label: 'linkedin_company_address', value: 34 },
  { label: 'linkedin_company_location', value: 35 },
  { label: 'linkedin_company_industry', value: 36 },
  { label: 'linkedin_company_size', value: 37 },
  { label: 'linkedin_company_year', value: 38 },
  { label: 'linkedin_company_id', value: 39 },
  { label: 'linkedin_company_url', value: 40 },
  { label: 'linkedin_profile_summary', value: 41 },
  { label: 'first_name', value: 42 },
  { label: 'last_name', value: 43 },
  // { label: "source_url", value: 11 },
  // End
  { label: 'city', value: 44 },
  { label: 'state', value: 45 },
  { label: 'country', value: 46 },
  { label: 'college', value: 47 },
  { label: 'degree', value: 48 },
  { label: 'dignissimos_beatae_t', value: 49 },
];

export const emailTemplateTags = [
  { label: 'name', value: '{{name}}' },
  { label: 'first_name', value: '{{first_name}}' },
  { label: 'last_name', value: '{{last_name}}' },
  { label: 'email', value: '{{email}}' },
  { label: 'title', value: '{{title}}' },
  { label: 'location', value: '{{location}}' },
  { label: 'phone_number', value: '{{phone_number}}' },
  { label: 'company', value: '{{company}}' },
  { label: 'url', value: '{{url}}' },
  { label: 'profile_url', value: '{{profile_url}}' },
  { label: 'error', value: '{{error}}' },
  { label: 'source_url', value: '{{source_url}}' },
  { label: 'location_city', value: '{{location_city}}' },
  { label: 'location_state', value: '{{location_state}}' },
  { label: 'dayofweek', value: '{{dayofweek}}' },
  { label: 'tomorrow', value: '{{tomorrow}}' },
  { label: 'nextbusinessday', value: '{{nextbusinessday}}' },
  { label: 'twobusinessdays', value: '{{twobusinessdays}}' },
];

export const emailTemplateTagsArray = [
  '{{first_name}}',
  '{{last_name}}',
  '{{email}}',
  '{{title}}',
  '{{location}}',
  '{{phone_number}}',
  '{{company}}',
  '{{url}}',
  '{{profile_url}}',
  '{{error}}',
  '{{source_url}}',
  '{{location_city}}',
  '{{location_state}}',
  '{{location_country}}',
  '{{dayofweek}}',
  '{{tomorrow}}',
  '{{nextbusinessday}}',
  '{{twobusinessdays}}',
];
export const gptTemplateTagsArray = [
  '{{resume_summary}}',
  '{{job_description}}',
  '{{resume_content}}',
];

export const emailTemplatesTagsArray = [
  '{{firstName}}', '{{payDate}}', '{{fullName}}', '{{greeting}}', '{{activityDate}}',
  '{{candidateFullName}}', '{{placementJobTitle}}', '{{jobCity}}',
  '{{jobStateCode}}', '{{clientName}}', '{{invoiceId}}', '{{agedDays}}', '{{billBoxTag}}',
  // AI Recruiter outreach merge fields (schedulingLink / rebookLink are the
  // tokenized URLs injected by the producer at send time)
  '{{candidateFirstName}}', '{{jobTitle}}', '{{companyName}}', '{{schedulingLink}}', '{{rebookLink}}',
  // AI Recruiter Interview Confirmation merge fields
  '{{scheduledDay}}', '{{scheduledTime}}', '{{callPhone}}'
];

export const companyNotesCategories = [
  { label: 'Phone Call', value: 'Phone Call' },
  { label: 'Business Development', value: 'Business Development' },
  { label: 'Email Sent', value: 'Email Sent' },
  { label: 'Email Received', value: 'Email Received' },
  { label: 'TJ Lookup Campaign', value: 'TJ Lookup Campaign' },
  { label: 'Client Interview Followup', value: 'Client Interview Followup' },
  { label: 'Candidate Submission', value: 'Candidate Submission' },
  { label: 'Text Message', value: 'Text Message' },
  { label: 'Client Visit', value: 'Client Visit' },
  {
    label: 'Company Specific Preference',
    value: 'Company Specific Preference',
  },
  { label: 'Benefits', value: 'Benefits' },
  { label: 'Linkedin', value: 'Linkedin' },
  { label: 'Invoice', value: 'Invoice' },
  { label: 'Contract Request Detail', value: 'Contract Request Detail' },
];

export const contactNotesCategories = [
  { label: 'Phone Call', value: 'Phone Call' },
  { label: 'Business Development', value: 'Business Development' },
  // { label: "Email Sent", value: "Email Sent" },
  // { label: "Email Received", value: "Email Received" },
  { label: 'TJ Lookup Campaign', value: 'TJ Lookup Campaign' },
  { label: 'Client Interview Followup', value: 'Client Interview Followup' },
  { label: 'Candidate Submission', value: 'Candidate Submission' },
  { label: 'Text Message', value: 'Text Message' },
  { label: 'Client Offer Feedback', value: 'Client Offer Feedback' },
  { label: 'Client Visit', value: 'Client Visit' },
  {
    label: 'Company Specific Preference',
    value: 'Company Specific Preference',
  },
  { label: 'Benefits', value: 'Benefits' },
  { label: 'Linkedin', value: 'Linkedin' },
  { label: 'Invoice', value: 'Invoice' },
  { label: 'Contract Request Detail', value: 'Contract Request Detail' },
];

export const jobNotesCategories = [
  { label: 'Job Brief', value: 'Job Brief' },
  { label: 'Phone Call', value: 'Phone Call' },
  { label: 'Email Sent', value: 'Email Sent' },
  { label: 'Email Received', value: 'Email Received' },
  { label: 'Internal Interview', value: 'Internal Interview' },
  { label: 'Candidate Submission', value: 'Candidate Submission' },
  { label: 'Candidate Withdrawn', value: 'Candidate Withdrawn' },
  { label: 'Filled by Competitor', value: 'Filled by Competitor' },
  { label: 'Client Withdraw', value: 'Client Withdraw' },
  { label: 'Text Message', value: 'Text Message' },
  { label: 'Interview Prep', value: 'Interview Prep' },
  { label: 'Interview Feedback', value: 'Interview Feedback' },
  { label: 'Client Interview Feedback', value: 'Client Interview Feedback' },
];

export const candidateNotesCategories = [
  { label: 'Phone Call', value: 'Phone Call' },
  { label: 'Email Sent', value: 'Email Sent' },
  { label: 'Email Received', value: 'Email Received' },
  { label: 'Text Message', value: 'Text Message' },
  { label: 'Transcript / Certificate', value: 'Transcript / Certificate' },
  {
    label: 'Request Further Information',
    value: 'Request Further Information',
  },
  { label: 'Interview Prep', value: 'Interview Prep' },
  { label: 'Interview Feedback', value: 'Interview Feedback' },
  { label: 'Client Interview Feedback', value: 'Client Interview Feedback' },
  { label: 'Reference', value: 'Reference' },
  { label: 'Left Message', value: 'Left Message' },
  { label: 'Monster', value: 'Monster' },
  { label: 'Linkedin', value: 'Linkedin' },
  { label: 'ZipRecruiter', value: 'ZipRecruiter' },
  { label: 'Indeed', value: 'Indeed' },
  { label: 'Assignment Status', value: 'Assignment Status' },
  { label: 'Internal Interview', value: 'Internal Interview' },
  { label: 'Internal Web Interview', value: 'Internal Web Interview' },
  { label: 'Candidate Merge', value: 'Candidate Merge' },
  { label: 'Offer Note', value: 'Offer Note' },
];

export const offerCategoryNotes = [
  { label: 'Candidate Offer Feedback', value: 'Candidate Offer Feedback' },
  { label: 'Client Offer Feedback', value: 'Client Offer Feedback' },
];

export const jobApplicantNotesCategories = [
  { label: 'Phone Call', value: 'Phone Call' },
  { label: 'Email Sent', value: 'Email Sent' },
  { label: 'Email Received', value: 'Email Received' },
  { label: 'Text Message', value: 'Text Message' },
];

export const notesCategories = [
  { label: 'Candidate', value: 'Candidate' },
  { label: 'Job', value: 'Job' },
  { label: 'Company', value: 'Company' },
  { label: 'Contact', value: 'Contact' },
  { label: 'Offer', value: 'Offer' },
  { label: 'Interview', value: 'Interview' },
  { label: 'Submission', value: 'Submission' },
  { label: 'Email Notes', value: 'EmailNotes' },
];

export const submissionNoteCategories = [
  { label: 'Internal Submission Note', value: 'Internal Submission Note' },
  { label: 'Client Submission Feedback', value: 'Client Submission Feedback' },
];

export const declineNoteCategories = [
  { label: 'Candidate Declined', value: 'Candidate Declined' },
  { label: 'Client Declined', value: 'Client Declined' },
  {
    label: 'Submission - Client Decline',
    value: 'Submission - Client Decline',
  },
  {
    label: 'Submission - Candidate Decline',
    value: 'Submission - Candidate Decline',
  },
  {
    label: 'Interview - Client Declined',
    value: 'Interview - Client Declined',
  },
  {
    label: 'Interview - Candidate Declined',
    value: 'Interview - Candidate Declined',
  },
];

export const allNotes = [
  ...interviewDetailsNotesCategories,
  ...submissionNoteCategories,
  ...jobApplicantNotesCategories,
  ...offerCategoryNotes,
  ...candidateNotesCategories,
  ...jobNotesCategories,
  ...declineNoteCategories,
  ...contactNotesCategories,
  ...companyNotesCategories,
];

export const allNoteCategory = allNotes.filter(
  (v, i, a) => a.findIndex((t) => t?.value === v?.value) === i
);

export const categoryEmailNotes = [
  {
    label: 'Email Sent',
    value: 'EMAIL_SENT',
  },
  {
    label: 'Email Received',
    value: 'EMAIL_RECEIVED',
  },
];

export enum DealType {
  TRAINED = 'Trained',
  UNDER_TRAINING = "Under Training"
}

export enum JobAppStatusEnum {
  APPLIED = 'Applied',
  CALLED = 'Called',
  KEEP = 'Keep',
  EMAILED = 'Emailed',
  CONTACT_LATER = 'Contact Later',
  CALL_SCHEDULED = 'Call Scheduled',
  WEB_INPERSON_SCREENED = 'Web/InPersonScreened',
  CANDIDATE_DECLINE = 'Candidate Decline',
  CLIENT_DECLINE = 'Client Decline',
  INTERVIEWED = 'Interview',
  SUBMITTED = 'Submission',
  REFERENCED = 'Reference',
  OFFERED = 'Offer',
  PLACED = 'Placement',
  REJECTED = 'Rejection',
  REJECTED_INTERNAL = 'Rejected_Internal',
  DECLINED = 'Declined',
  IN_KEEP_LIST = 'In_Keep_List',
  IN_EXCLUDED_LIST = 'In_Excluded_List',
  WEB_SCREEN = 'Web_Screen',
  SUBMITTED_TO_CLIENT = 'Submitted_to_Client',
  CLIENT_INTERVIEW_1 = 'Client Interview 1',
  INTERNAL_SUBMITTAL = 'Internal_Submittal',
  PLACED_TEMP = 'Placed_Temp',
  CANDIDATE_WITHDREW = 'Candidate_Withdrew',
}

export const sortingAlphabetical = (arr) => {
  return arr.sort((a: { label: number }, b: { label: number }) =>
    a.label < b.label ? -1 : a.label > b.label ? 1 : 0
  );
};

export const EmailCategoryEnum = {
  EMAIL_SENT: 'Email Sent',
  EMAIL_RECEIVED: 'Email Received',
};

export const intersellerContactsFilterForCard = [
  { label: 'All Contacts', value: 'total' },
  { label: 'On Going', value: 'ongoing' },
  { label: 'Messaged', value: 'messaged' },
  { label: 'Opened', value: 'viewed' },
  { label: 'Replied', value: 'replied' },
  { label: 'Bounced', value: 'bounced' },
  { label: 'Need Attention', value: 'error' },
];

export const OPTIONS = {
  bounced: [
    { label: 'Fix Email', value: 'Fix_Email' },
    { label: 'Set Replied', value: 'Set_Replied' },
  ],

  messaged: [
    { label: 'Set Booked', value: 'Set_Booked' },
    { label: 'Set Replied', value: 'Set_Replied' },
    { label: 'Pause Contact', value: 'total' },
    { label: 'Unsubscribe', value: 'Unsubscribe' },
    { label: 'Block', value: 'Block' },
  ],
  added: [
    { label: 'Set Booked', value: 'Set_Booked' },
    { label: 'Set Replied', value: 'Set_Replied' },
    { label: 'Pause Contact', value: 'total' },
    { label: 'Unsubscribe', value: 'Unsubscribe' },
    { label: 'Block', value: 'Block' },
  ],

  booked: [
    { label: 'Remove Booked', value: 'remove_Booked' },
    { label: 'Assign Sentiment', value: 'Assign Sentiment' },
    { label: 'Unsubscribe', value: 'Unsubscribe' },
  ],

  replied: [
    { label: 'Remove Reply', value: 'Remove_reply' },
    { label: 'Set Booked', value: 'Set_Booked' },
    { label: 'Assign Sentiment', value: 'Assign Sentiment' },
    { label: 'Unsubscribe', value: 'Unsubscribe' },
    { label: 'Block', value: 'Block' },
  ],

  pause: [
    { label: 'Resume Emails', value: 'Resume Emails' },
    { label: 'Set Replied', value: 'Set_Replied' },
    { label: 'Unsubscribe', value: 'Unsubscribe' },
    { label: 'Block', value: 'Block' },
  ],
};

export const BlockOptions = [
  { label: 'Add to my personal block list', value: 'Personal_block_list' },
  { label: "Add to my team's block list", value: 'Team_block_list' },
];

export const sentimentOptions = [
  { label: 'Interested', value: 'INTERESTED' },
  { label: 'Not Interested', value: 'NOT_INTERESTED' },
  { label: 'Bad Fit', value: 'BAD_FIT' },
  { label: 'Wrong Contact', value: 'WRONG_CONTACT' },
  { label: 'Bad Timing', value: 'TIMING' },
];

export const RouteList = {
  '/companies': [
    'companies',
    'company-details',
    'update-company',
    'create-company',
  ],
  '/contacts': [
    'contacts',
    'contact-details',
    'update-company-contact',
    'create-contacts',
  ],
  '/agreements': [
    'agreements',
    'view-agreement',
    'update-agreement',
    'legacy-agreements',
    'create-legacy-agreement',
    'create-agreement',
  ],
  '/job-orders': ['job-order', 'job-orders', 'update-job-order'],
  '/candidates': ['candidates', 'candidate'],
  '/job-applicants': ['job-applicants', 'job-applicant'],
  '/sequences': ['sequences'],
  '/candidate-pipeline': ['candidate-pipeline'],
  '/placement-management': ['placement-management'],
  '/recruiter/folders': ['recruiter'],
  '/settings': [
    'admin',
    'reports',
    'notifications',
    'settings',
    'merge-company',
    'merge-contacts',
    'merge-candidate',
    'accounting-dashboard',
    'org-chart',
  ],
};
export const countriesOption = [
  { label: 'US', value: 'US' },
  { label: 'UK', value: 'UK' },
  { label: 'CA', value: 'CA' },
  { label: 'MX', value: 'MX' },
]
export const countries = [
  { label: 'US', value: 'US', phonecode: '+1' },
  { label: 'UK', value: 'UK', phonecode: '+44' },
  { label: 'CA', value: 'CA', phonecode: '+1' },
];

export const CANDIDATE_ONLY = [
  { label: 'MX', value: 'MX', phonecode: '+52' },
];

export const countriesIsoCodeDto = {
  US: 'US',
  UK: 'GB',
};


export const AgreementTypeDTO = {
  DIRECT_HIRE: "DIRECT HIRE",
  LEGAL_DIRECT_HIRE: "LEGACY DIRECT HIRE",
  LEGAL_CONTRACT: "LEGACY TEMP",
  TEMP: "TEMP",
  CUSTOM: "CUSTOM",
}

export const DtoForPlacement = {
  DRAFT: 'Draft',
  PENDING_AM: 'Pending_AM',
  PENDING_MANAGER: 'Pending_Mgr',
  PENDING_RECRUITER: 'Pending_Rec',
  PENDING_ACCOUNTING: 'Pending_Acctg',
  ACCOUNTING_APPROVED: 'Acctg_Apprvd',
  ACCOUNTING_INVOICED: 'Acctg_Invoiced',
  PLACEMENT_CANCELLED: 'Placement_Cancelled',
  REJECTED_AM: 'Rejected_AM',
  REJECTED_MANAGER: 'Rejected_Mgr',
  REJECTED_ACCOUNTING: 'Rejected_Acctg',
  REJECTED_RECRUITER: 'Rejected_Rec',
  ASSIGNMENT_COMPLETED: 'Assgmnt_Completed',
  ASSIGNMENT_CANCELLED: 'Assgmnt_Cancelled',
  ASSIGNMENT_CONVERTED: 'Assgmnt_Converted',
  PLACEMENT_ENDED: "Placement_Ended",
  REQUEST_PLACEMENT_CANCELLED: 'Cancelation_Request',
  PAID: "Paid"

};

export const HEADERS_ITEM_WITHOUT_INPUT = [
  'ID',
  'Start Date',
  'month',
  'Billing Type',
  'Amount',
  'Place Status',
  'Actions',
  'Month',
  'Place Date',
  'Type',
  'Paid On',
  'Net Fee',
  'year',
  'Agreements',
  'Last Update',
  'Status',
  'Active Jobs',
  'Candidate Status',
  'Resume Updated',
  'Source',
  'Job Status',
  'Posted',
  'Work Type',
  'Action',
  'Company Size',
  'Fee',
  'Document',
  'Signed At',
  'Agreement Status',
  'Type',
  'Contact Status',
  'Interviews',
  'owner',
  'Website',
  'Candidates',
  'Salary',
  'Description',
  'Location',
  'Finalist',
  'Urgency',
  'Pipeline',
  'ATS',
  'LinkedIn',
  'Recruiters',
  'Date',
  'User Name',
  'User Email',
  'User Phone',
  'User Status',
  'User Role',
  'Month/Yr',
  'File',
  'File Type',
  'Uploaded By',
  'Email Status',
  'Uploaded On',
  'Stage',
  'Note',
  'Last Updated',
  'Rate',
  'Commission',
  'Due Date',
  'Payout',
  'AM/Rec',
  // kan-101 reconciliation listing — display-only columns.
  'Received',
  'Invoices',
  'Recon Status',
  'Activity Report',
];
export const HEADERS_ITEM_WITH_NUMERIC_FIELD = [
  'Net Fee',
  'ID',
  'year',

];
export const HEADERS_ITEM_WITHOUT_ARROW = [
  'Place Status',
  'Actions',
  'Month',
  'Year',
  'Amount',
  'Billing Type',
  'Placement Type',
  'Agreements',
  'Company Size',
  'Website',
  'Candidate Status',
  'Active Jobs',
  'Last Update',
  'Posted',
  'Action',
  'Resume Updated',
  'Source',
  'Fee',
  'Document',
  "Phone",
  'Interviews',
  'owner',
  'Website',
  'Candidates',
  'Salary',
  'Description',
  'Location',
  'Finalist',
  'Urgency',
  'Pipeline',
  'ATS',
  'LinkedIn',
  'Recruiters',
  'User Status',
  'User Name',
  'User Email',
  'User Phone',
  'User Role',
  'User Status',
  'File',
  'Month/Yr',
  'File Type',
  'Uploaded By',
  'Email Status',
  'Uploaded On',
  'Company / Job',
  'Candidate',
  'Stage',
  'Note',
  'Last Updated',
  'Rate',
  'Due Date',
  'Payout',
  'AM/Rec',
  // kan-101 reconciliation listing — nothing here is server-sortable yet.
  'Payment Ref',
  'Received',
  'Invoices',
  'Recon Status',
  'Activity Report',
];

export const ALL_IMPORTS_HEADER = [
  "File",
  "Source",
  "Uploaded By",
  "Upload Date",
  "Total Rows",
  "Status",
  "Action"
];

export const ADMIN_IMPORTS_HEADER = [
  "File",
  "Source",
  "Uploaded By",
  "Upload Date",
  "Status",
  "Action"
];

export const CONTACT_IMPORTS_HEADER = [
  "File",
  "Uploaded By",
  "Upload Date",
  "Count",
  "Sent",
  "Status",
  "Action"
];

export const TEMP_BILLING_IMPORTS_HEADER = [
  // kan-106: 'File Name' is deliberately NOT in HEADERS_ITEM_WITHOUT_INPUT /
  // HEADERS_ITEM_WITHOUT_ARROW, so it gets a text search input and a sort arrow
  // (the plain 'File' label stays display-only for the reconciliation table).
  // 'File Type' is listed in HEADERS_ITEM_WITH_SELECTED, so it renders a select.
  { fileNameSearch: 'File Name' }, { reportTypeSearch: 'File Type' }, { monthYrSearch: 'Month/Yr' },
  { UploadedBy: "Uploaded By" }, { UploaedOn: "Uploaded On" }, { actions: 'Actions' }
]

// kan-101. Only `referenceIdSearch` and `monthYrSearch` are searchable; the rest
// are display-only, which is why their labels are listed in both
// HEADERS_ITEM_WITHOUT_INPUT and HEADERS_ITEM_WITHOUT_ARROW below.
export const TEMP_BILLING_RECONCILIATION_HEADER = [
  { referenceIdSearch: 'Payment Ref' }, { receivedDate: 'Received' }, { File: 'File' },
  { monthYrSearch: 'Month/Yr' }, { invoices: 'Invoices' }, { reconStatus: 'Recon Status' },
  { activityReport: 'Activity Report' }, { actions: 'Actions' }
]
export const HEADERS_ITEM_WITH_SELECTED = ['Type', 'Place Status', 'month', 'User Status', 'Placement Type', 'Candidate Status', 'Status', 'Job Status', 'Posted', 'Work Type', 'Agreement Status', 'Contact Status', 'User Status', 'Stage', 'Billing Type', 'File Type'];
export const HEADERS_ITEM_WITH_CALENDER = ['Start Date', 'Place Date', 'Paid On', 'Month/Yr'];

export interface COLUMN_INTERFACE_TYPES_For_PLACEMENT {
  // searches
  candidateSearch: string;
  jobTitleSearch: string;
  netFeeSearch: number | null;
  IdSearch: number | null;
  statusSearch: string;
  placementTypeSearch: string;
  startDateSearch: string;
  placeDateSearch: string;
  accountManagerSearch: string;
  RecruiterSearch: string;
  workLocationSearch: string;
  // Sort
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}
export interface COLUMN_INTERFACE_TYPES_For_PLACEMENT {
  // searches
  candidateSearch: string;
  jobTitleSearch: string;
  netFeeSearch: number | null;
  IdSearch: number | null;
  statusSearch: string;
  placementTypeSearch: string;
  startDateSearch: string;
  placeDateSearch: string;
  accountManagerSearch: string;
  RecruiterSearch: string;
  workLocationSearch: string;
  // Sort
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}


export interface COLUMN_INTERFACE_TYPES_For_COMPANY {
  // searches
  companySearch: string;
  locationSearch: string;
  stausSearch: string;

  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}
export interface COLUMN_INTERFACE_TYPES_FOR_CONTACT {
  // searches
  fullNameSearch: string;
  titleSearch: string;
  emailSearch: string;
  contactStatusSearch: string;
  companyNameSearch: string;
  phoneSearch: string;
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}

export interface COLUMN_INTERFACE_TYPES_FOR_CANDIDATE {
  // searches
  // emptySearch: string;
  nameSearch: string;
  jobTitleSearch: string;
  emailSearch: string;
  locationSearch: string;
  candidateStatusSearch: string;
  phoneSearch: string
  // Sort
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}

export interface COLUMN_INTERFACE_TYPES_FOR_ACTIVITY_DASHBOARD {
  companySearch: string;
  candidateSearch: string;
  stageSearch: string;
  sorting: {
    columnName: string | null;
    columnValue: string | null;
  };
}

export interface COLUMN_INTERFACE_TYPES_FOR_USER_ACTIVITY_REPORT {
  userSearch: string;
  monthSearch: string;
  yearSearch: string;
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}
export interface COLUMN_INTERFACE_TYPES_FOR_TEMP_BILLING_IMPORTS {
  monthYrSearch: string;
  /** kan-106: case-insensitive "contains" match on the file name. */
  fileNameSearch: string;
  /** kan-106: exact report type (the enum VALUE, e.g. WEEKLY_ACTIVITY_REPORT_TYPE); '' means all. */
  reportTypeSearch: string;
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}
export interface COLUMN_INTERFACE_TYPES_FOR_TEMP_BILLING_RECONCILIATION {
  referenceIdSearch: string;
  /**
   * kan-101: the Month select was removed from the toolbar (no useful data to
   * filter on yet). The server still accepts monthYrSearch, so this stays
   * optional rather than being deleted — an Activity Report filter is the likely
   * successor and can reuse the same shape.
   */
  monthYrSearch?: string;
  /** kan-101: exact 'YYYY-MM' activity-report tag; '' means all. */
  activityReportSearch?: string;
  /** kan-112: narrows to the payment(s) whose file carries this invoice number. */
  invoiceNumberSearch?: string;
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}
export interface COLUMN_INTERFACE_TYPES_FOR_AGREEMENTS {

  companySearch: string;
  contactSearch: string;
  nickNameSearch: string;
  typeSearch: string;
  accountManagerSearch: string;
  statusSearch: string
  // Sort
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}

export interface HotJobOrdersFilterInput {
  company: String
  status: String
  position: String
}

export interface COLUMN_INTERFACE_TYPES_FOR_JOB_ORDER {
  // searches
  // emptySearch: string;
  jobTitleSearch: string;
  companySearch: string;
  companyownerSearch: string;
  locationSearch: string;
  // workTypeSearch: string;
  postedSearch: string;
  statusSearch: string;
  mainContactSearch: string;
  // Sort
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}

export interface COLUMN_INTERFACE_TYPES_FOR_JOB_LIST {
  positionSearch: string;
  companySearch: string;
  createdAt: string
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}

export interface COLUMN_INTERFACE_TYPES_FOR_COMPANY_EXPIRY_REPORT {
  // Sort
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}
export interface COLUMN_INTERFACE_TYPES_For_ACCOUNTING_DASHBOARD {
  // searches
  candidateSearch: string;
  jobTitleSearch: string;
  netFeeSearch: number | null;
  IdSearch: number | null;
  statusSearch: string;
  placementTypeSearch: string;
  startDateSearch: string;
  paidAtSearch: string;
  placeDateSearch: string;
  accountManagerSearch: string;
  jobOwnerSearch: string;
  RecruiterSearch: string;
  workLocationSearch: string;
  // Not a table column — the Commissions filter bar control ('COMPLETE' |
  // 'INCOMPLETE' | ''); it rides along here so it persists in the URL.
  commissionSearch: string;
  // Sort
  sorting: {
    columnName: string | null,
    columnValue: string | null
  }
}
export const JobOrderStatusForHeader = [
  ...JobOrderStatusInApplicant,
  { label: 'Filled By Us', value: 'FILLED_BY_US' },
  { label: 'Filled By Client', value: 'FILLED_BY_CLIENT' },
  { label: 'Lost Competitor', value: 'LOST_TO_COMPETITOR' },
  { label: 'Cancelled', value: 'CANCELLED' },
  { label: 'Hold', value: 'HOLD' },
  { label: 'My Job Order', value: 'MY_JOB_ORDERS' },
  { label: 'Duplicated Job', value: 'DUPLICATED_JOB' },
];

export const INTERSELLER_TIME_ZONES = [
  { value: 'Africa/Abidjan', label: 'Africa/Abidjan' },
  { value: 'Africa/Accra', label: 'Africa/Accra' },
  { value: 'Africa/Addis_Ababa', label: 'Africa/Addis_Ababa' },
  { value: 'Africa/Algiers', label: 'Africa/Algiers' },
  { value: 'Africa/Asmara', label: 'Africa/Asmara' },
  { value: 'Africa/Bamako', label: 'Africa/Bamako' },
  { value: 'Africa/Bangui', label: 'Africa/Bangui' },
  { value: 'Africa/Banjul', label: 'Africa/Banjul' },
  { value: 'Africa/Bissau', label: 'Africa/Bissau' },
  { value: 'Africa/Blantyre', label: 'Africa/Blantyre' },
  { value: 'Africa/Brazzaville', label: 'Africa/Brazzaville' },
  { value: 'Africa/Bujumbura', label: 'Africa/Bujumbura' },
  { value: 'Africa/Cairo', label: 'Africa/Cairo' },
  { value: 'Africa/Casablanca', label: 'Africa/Casablanca' },
  { value: 'Africa/Ceuta', label: 'Africa/Ceuta' },
  { value: 'Africa/Conakry', label: 'Africa/Conakry' },
  { value: 'Africa/Dakar', label: 'Africa/Dakar' },
  { value: 'Africa/Dar_es_Salaam', label: 'Africa/Dar_es_Salaam' },
  { value: 'Africa/Djibouti', label: 'Africa/Djibouti' },
  { value: 'Africa/Douala', label: 'Africa/Douala' },
  { value: 'Africa/El_Aaiun', label: 'Africa/El_Aaiun' },
  { value: 'Africa/Freetown', label: 'Africa/Freetown' },
  { value: 'Africa/Gaborone', label: 'Africa/Gaborone' },
  { value: 'Africa/Harare', label: 'Africa/Harare' },
  { value: 'Africa/Johannesburg', label: 'Africa/Johannesburg' },
  { value: 'Africa/Juba', label: 'Africa/Juba' },
  { value: 'Africa/Kampala', label: 'Africa/Kampala' },
  { value: 'Africa/Khartoum', label: 'Africa/Khartoum' },
  { value: 'Africa/Kigali', label: 'Africa/Kigali' },
  { value: 'Africa/Kinshasa', label: 'Africa/Kinshasa' },
  { value: 'Africa/Lagos', label: 'Africa/Lagos' },
  { value: 'Africa/Libreville', label: 'Africa/Libreville' },
  { value: 'Africa/Lome', label: 'Africa/Lome' },
  { value: 'Africa/Luanda', label: 'Africa/Luanda' },
  { value: 'Africa/Lubumbashi', label: 'Africa/Lubumbashi' },
  { value: 'Africa/Lusaka', label: 'Africa/Lusaka' },
  { value: 'Africa/Malabo', label: 'Africa/Malabo' },
  { value: 'Africa/Maputo', label: 'Africa/Maputo' },
  { value: 'Africa/Maseru', label: 'Africa/Maseru' },
  { value: 'Africa/Mbabane', label: 'Africa/Mbabane' },
  { value: 'Africa/Mogadishu', label: 'Africa/Mogadishu' },
  { value: 'Africa/Monrovia', label: 'Africa/Monrovia' },
  { value: 'Africa/Nairobi', label: 'Africa/Nairobi' },
  { value: 'Africa/Ndjamena', label: 'Africa/Ndjamena' },
  { value: 'Africa/Niamey', label: 'Africa/Niamey' },
  { value: 'Africa/Nouakchott', label: 'Africa/Nouakchott' },
  { value: 'Africa/Ouagadougou', label: 'Africa/Ouagadougou' },
  { value: 'Africa/Porto-Novo', label: 'Africa/Porto-Novo' },
  { value: 'Africa/Sao_Tome', label: 'Africa/Sao_Tome' },
  { value: 'Africa/Tripoli', label: 'Africa/Tripoli' },
  { value: 'Africa/Tunis', label: 'Africa/Tunis' },
  { value: 'Africa/Windhoek', label: 'Africa/Windhoek' },
  { value: 'America/Adak', label: 'America/Adak' },
  { value: 'America/Anchorage', label: 'America/Anchorage' },
  { value: 'America/Anguilla', label: 'America/Anguilla' },
  { value: 'America/Antigua', label: 'America/Antigua' },
  { value: 'America/Araguaina', label: 'America/Araguaina' },
  {
    value: 'America/Argentina/Buenos_Aires',
    label: 'America/Argentina/Buenos_Aires',
  },
  {
    value: 'America/Argentina/Catamarca',
    label: 'America/Argentina/Catamarca',
  },
  { value: 'America/Argentina/Cordoba', label: 'America/Argentina/Cordoba' },
  { value: 'America/Argentina/Jujuy', label: 'America/Argentina/Jujuy' },
  { value: 'America/Argentina/La_Rioja', label: 'America/Argentina/La_Rioja' },
  { value: 'America/Argentina/Mendoza', label: 'America/Argentina/Mendoza' },
  {
    value: 'America/Argentina/Rio_Gallegos',
    label: 'America/Argentina/Rio_Gallegos',
  },
  { value: 'America/Argentina/Salta', label: 'America/Argentina/Salta' },
  { value: 'America/Argentina/San_Juan', label: 'America/Argentina/San_Juan' },
  { value: 'America/Argentina/San_Luis', label: 'America/Argentina/San_Luis' },
  { value: 'America/Argentina/Tucuman', label: 'America/Argentina/Tucuman' },
  { value: 'America/Argentina/Ushuaia', label: 'America/Argentina/Ushuaia' },
  { value: 'America/Aruba', label: 'America/Aruba' },
  { value: 'America/Asuncion', label: 'America/Asuncion' },
  { value: 'America/Atikokan', label: 'America/Atikokan' },
  { value: 'America/Bahia', label: 'America/Bahia' },
  { value: 'America/Bahia_Banderas', label: 'America/Bahia_Banderas' },
  { value: 'America/Barbados', label: 'America/Barbados' },
  { value: 'America/Belem', label: 'America/Belem' },
  { value: 'America/Belize', label: 'America/Belize' },
  { value: 'America/Blanc-Sablon', label: 'America/Blanc-Sablon' },
  { value: 'America/Boa_Vista', label: 'America/Boa_Vista' },
  { value: 'America/Bogota', label: 'America/Bogota' },
  { value: 'America/Boise', label: 'America/Boise' },
  { value: 'America/Cambridge_Bay', label: 'America/Cambridge_Bay' },
  { value: 'America/Campo_Grande', label: 'America/Campo_Grande' },
  { value: 'America/Cancun', label: 'America/Cancun' },
  { value: 'America/Caracas', label: 'America/Caracas' },
  { label: 'America/Cayenne', value: 'America/Cayenne' },
  { label: 'America/Cayman', value: 'America/Cayman' },
  { label: 'America/Chicago', value: 'America/Chicago' },
  { label: 'America/Chihuahua', value: 'America/Chihuahua' },
  { label: 'America/Costa_Rica', value: 'America/Costa_Rica' },
  { label: 'America/Creston', value: 'America/Creston' },
  { label: 'America/Cuiaba', value: 'America/Cuiaba' },
  { label: 'America/Curacao', value: 'America/Curacao' },
  { label: 'America/Danmarkshavn', value: 'America/Danmarkshavn' },
  { label: 'America/Dawson', value: 'America/Dawson' },
  { label: 'America/Dawson_Creek', value: 'America/Dawson_Creek' },
  { label: 'America/Denver', value: 'America/Denver' },
  { label: 'America/Detroit', value: 'America/Detroit' },
  { label: 'America/Dominica', value: 'America/Dominica' },
  { label: 'America/Edmonton', value: 'America/Edmonton' },
  { label: 'America/Eirunepe', value: 'America/Eirunepe' },
  { label: 'America/El_Salvador', value: 'America/El_Salvador' },
  { label: 'America/Fort_Nelson', value: 'America/Fort_Nelson' },
  { label: 'America/Fortaleza', value: 'America/Fortaleza' },
  { label: 'America/Glace_Bay', value: 'America/Glace_Bay' },
  { label: 'America/Godthab', value: 'America/Godthab' },
  { label: 'America/Goose_Bay', value: 'America/Goose_Bay' },
  { label: 'America/Grand_Turk', value: 'America/Grand_Turk' },
  { label: 'America/Grenada', value: 'America/Grenada' },
  { label: 'America/Guadeloupe', value: 'America/Guadeloupe' },
  { label: 'America/Guatemala', value: 'America/Guatemala' },
  { label: 'America/Guayaquil', value: 'America/Guayaquil' },
  { label: 'America/Guyana', value: 'America/Guyana' },
  { label: 'America/Halifax', value: 'America/Halifax' },
  { label: 'America/Havana', value: 'America/Havana' },
  { label: 'America/Hermosillo', value: 'America/Hermosillo' },
  {
    label: 'America/Indiana/Indianapolis',
    value: 'America/Indiana/Indianapolis',
  },
  { label: 'America/Indiana/Knox', value: 'America/Indiana/Knox' },
  { label: 'America/Indiana/Marengo', value: 'America/Indiana/Marengo' },
  { label: 'America/Indiana/Petersburg', value: 'America/Indiana/Petersburg' },
  { label: 'America/Indiana/Tell_City', value: 'America/Indiana/Tell_City' },
  { label: 'America/Indiana/Vevay', value: 'America/Indiana/Vevay' },
  { label: 'America/Indiana/Vincennes', value: 'America/Indiana/Vincennes' },
  { label: 'America/Indiana/Winamac', value: 'America/Indiana/Winamac' },
  { label: 'America/Inuvik', value: 'America/Inuvik' },
  { label: 'America/Iqaluit', value: 'America/Iqaluit' },
  { label: 'America/Jamaica', value: 'America/Jamaica' },
  { label: 'America/Juneau', value: 'America/Juneau' },
  {
    label: 'America/Kentucky/Louisville',
    value: 'America/Kentucky/Louisville',
  },
  {
    label: 'America/Kentucky/Monticello',
    value: 'America/Kentucky/Monticello',
  },
  { label: 'America/Kralendijk', value: 'America/Kralendijk' },
  { label: 'America/La_Paz', value: 'America/La_Paz' },
  { label: 'America/Lima', value: 'America/Lima' },
  { label: 'America/Los_Angeles', value: 'America/Los_Angeles' },
  { label: 'America/Lower_Princes', value: 'America/Lower_Princes' },
  { label: 'America/Maceio', value: 'America/Maceio' },
  { label: 'America/Managua', value: 'America/Managua' },
  { label: 'America/Manaus', value: 'America/Manaus' },
  { label: 'America/Marigot', value: 'America/Marigot' },
  { label: 'America/Martinique', value: 'America/Martinique' },
  { label: 'America/Matamoros', value: 'America/Matamoros' },
  { label: 'America/Mazatlan', value: 'America/Mazatlan' },
  { label: 'America/Menominee', value: 'America/Menominee' },
  { label: 'America/Merida', value: 'America/Merida' },
  { label: 'America/Metlakatla', value: 'America/Metlakatla' },
  { label: 'America/Mexico_City', value: 'America/Mexico_City' },
  { label: 'America/Miquelon', value: 'America/Miquelon' },
  { label: 'America/Moncton', value: 'America/Moncton' },
  { label: 'America/Monterrey', value: 'America/Monterrey' },
  { label: 'America/Montevideo', value: 'America/Montevideo' },
  { label: 'America/Montserrat', value: 'America/Montserrat' },
  { label: 'America/Nassau', value: 'America/Nassau' },
  { label: 'America/New_York', value: 'America/New_York' },
  { label: 'America/Nipigon', value: 'America/Nipigon' },
  { label: 'America/Nome', value: 'America/Nome' },
  { label: 'America/Noronha', value: 'America/Noronha' },
  { label: 'America/North_Dakota/Beulah', value: 'America/North_Dakota/Beulah' },
  { label: 'America/North_Dakota/Center', value: 'America/North_Dakota/Center' },
  {
    label: 'America/North_Dakota/New_Salem',
    value: 'America/North_Dakota/New_Salem',
  },
  { label: 'America/Ojinaga', value: 'America/Ojinaga' },
  { label: 'America/Panama', value: 'America/Panama' },
  { label: 'America/Pangnirtung', value: 'America/Pangnirtung' },
  { label: 'America/Phoenix', value: 'America/Phoenix' },
  { label: 'America/Port-au-Prince', value: 'America/Port-au-Prince' },
  { label: 'America/Port_of_Spain', value: 'America/Port_of_Spain' },
  { label: 'America/Porto_Velho', value: 'America/Porto_Velho' },
  { label: 'America/Puerto_Rico', value: 'America/Puerto_Rico' },
  { label: 'America/Punta_Arenas', value: 'America/Punta_Arenas' },
  { label: 'America/Rainy_River', value: 'America/Rainy_River' },
  { label: 'America/Rankin_Inlet', value: 'America/Rankin_Inlet' },
  { label: 'America/Recife', value: 'America/Recife' },
  { label: 'America/Regina', value: 'America/Regina' },
  { label: 'America/Resolute', value: 'America/Resolute' },
  { label: 'America/Rio_Branco', value: 'America/Rio_Branco' },
  { label: 'America/Santa_Isabel', value: 'America/Santa_Isabel' },
  { label: 'America/Santarem', value: 'America/Santarem' },
  { label: 'America/Santiago', value: 'America/Santiago' },
  { label: 'America/Santo_Domingo', value: 'America/Santo_Domingo' },
  { label: 'America/Sao_Paulo', value: 'America/Sao_Paulo' },
  { label: 'America/Scoresbysund', value: 'America/Scoresbysund' },
  { label: 'America/Sitka', value: 'America/Sitka' },
  { label: 'America/St_Barthelemy', value: 'America/St_Barthelemy' },
  { label: 'America/St_Johns', value: 'America/St_Johns' },
  { label: 'America/St_Kitts', value: 'America/St_Kitts' },
  { label: 'America/St_Lucia', value: 'America/St_Lucia' },
  { label: 'America/St_Thomas', value: 'America/St_Thomas' },
  { label: 'America/St_Vincent', value: 'America/St_Vincent' },
  { label: 'America/Swift_Current', value: 'America/Swift_Current' },
  { label: 'America/Tegucigalpa', value: 'America/Tegucigalpa' },
  { label: 'America/Thule', value: 'America/Thule' },
  { label: 'America/Thunder_Bay', value: 'America/Thunder_Bay' },
  { label: 'America/Tijuana', value: 'America/Tijuana' },
  { label: 'America/Toronto', value: 'America/Toronto' },
  { label: 'America/Tortola', value: 'America/Tortola' },
  { label: 'America/Vancouver', value: 'America/Vancouver' },
  { label: 'America/Whitehorse', value: 'America/Whitehorse' },
  { label: 'America/Winnipeg', value: 'America/Winnipeg' },
  { label: 'America/Yakutat', value: 'America/Yakutat' },
  { label: 'America/Yellowknife', value: 'America/Yellowknife' },
  { label: 'Antarctica/Casey', value: 'Antarctica/Casey' },
  { label: 'Antarctica/Davis', value: 'Antarctica/Davis' },
  { label: 'Antarctica/DumontDUrville', value: 'Antarctica/DumontDUrville' },
  { label: 'Antarctica/Macquarie', value: 'Antarctica/Macquarie' },
  { label: 'Antarctica/Mawson', value: 'Antarctica/Mawson' },
  { label: 'Antarctica/McMurdo', value: 'Antarctica/McMurdo' },
  { label: 'Antarctica/Palmer', value: 'Antarctica/Palmer' },
  { label: 'Antarctica/Rothera', value: 'Antarctica/Rothera' },
  { label: 'Antarctica/Syowa', value: 'Antarctica/Syowa' },
  { label: 'Antarctica/Troll', value: 'Antarctica/Troll' },
  { label: 'Antarctica/Vostok', value: 'Antarctica/Vostok' },
  { label: 'Asia/Aden', value: 'Asia/Aden' },
  { label: 'Asia/Almaty', value: 'Asia/Almaty' },
  { label: 'Asia/Amman', value: 'Asia/Amman' },
  { label: 'Asia/Anadyr', value: 'Asia/Anadyr' },
  { label: 'Asia/Aqtau', value: 'Asia/Aqtau' },
  { label: 'Asia/Aqtobe', value: 'Asia/Aqtobe' },
  { label: 'Asia/Ashgabat', value: 'Asia/Ashgabat' },
  { label: 'Asia/Atyrau', value: 'Asia/Atyrau' },
  { label: 'Asia/Baghdad', value: 'Asia/Baghdad' },
  { label: 'Asia/Bahrain', value: 'Asia/Bahrain' },
  { label: 'Asia/Baku', value: 'Asia/Baku' },
  { label: 'Asia/Bangkok', value: 'Asia/Bangkok' },
  { label: 'Asia/Barnaul', value: 'Asia/Barnaul' },
  { label: 'Asia/Beirut', value: 'Asia/Beirut' },
  { label: 'Asia/Bishkek', value: 'Asia/Bishkek' },
  { label: 'Asia/Brunei', value: 'Asia/Brunei' },
  { label: 'Asia/Chita', value: 'Asia/Chita' },
  { label: 'Asia/Choibalsan', value: 'Asia/Choibalsan' },
  { label: 'Asia/Colombo', value: 'Asia/Colombo' },
  { label: 'Asia/Damascus', value: 'Asia/Damascus' },
  { label: 'Asia/Dhaka', value: 'Asia/Dhaka' },
  { label: 'Asia/Dili', value: 'Asia/Dili' },
  { label: 'Asia/Dubai', value: 'Asia/Dubai' },
  { label: 'Asia/Dushanbe', value: 'Asia/Dushanbe' },
  { label: 'Asia/Famagusta', value: 'Asia/Famagusta' },
  { label: 'Asia/Gaza', value: 'Asia/Gaza' },
  { label: 'Asia/Hebron', value: 'Asia/Hebron' },
  { label: 'Asia/Ho_Chi_Minh', value: 'Asia/Ho_Chi_Minh' },
  { label: 'Asia/Hong_Kong', value: 'Asia/Hong_Kong' },
  { label: 'Asia/Hovd', value: 'Asia/Hovd' },
  { label: 'Asia/Irkutsk', value: 'Asia/Irkutsk' },
  { label: 'Asia/Jakarta', value: 'Asia/Jakarta' },
  { label: 'Asia/Jayapura', value: 'Asia/Jayapura' },
  { label: 'Asia/Jerusalem', value: 'Asia/Jerusalem' },
  { label: 'Asia/Kabul', value: 'Asia/Kabul' },
  { label: 'Asia/Kamchatka', value: 'Asia/Kamchatka' },
  { label: 'Asia/Karachi', value: 'Asia/Karachi' },
  { label: 'Asia/Kathmandu', value: 'Asia/Kathmandu' },
  { label: 'Asia/Khandyga', value: 'Asia/Khandyga' },
  { label: 'Asia/Kolkata', value: 'Asia/Kolkata' },
  { label: 'Asia/Krasnoyarsk', value: 'Asia/Krasnoyarsk' },
  { label: 'Asia/Kuala_Lumpur', value: 'Asia/Kuala_Lumpur' },
  { label: 'Asia/Kuching', value: 'Asia/Kuching' },
  { label: 'Asia/Kuwait', value: 'Asia/Kuwait' },
  { label: 'Asia/Macau', value: 'Asia/Macau' },
  { label: 'Asia/Magadan', value: 'Asia/Magadan' },
  { label: 'Asia/Makassar', value: 'Asia/Makassar' },
  { label: 'Asia/Manila', value: 'Asia/Manila' },
  { label: 'Asia/Muscat', value: 'Asia/Muscat' },
  { label: 'Asia/Nicosia', value: 'Asia/Nicosia' },
  { label: 'Asia/Novokuznetsk', value: 'Asia/Novokuznetsk' },
  { label: 'Asia/Novosibirsk', value: 'Asia/Novosibirsk' },
  { label: 'Asia/Omsk', value: 'Asia/Omsk' },
  { label: 'Asia/Oral', value: 'Asia/Oral' },
  { label: 'Asia/Phnom_Penh', value: 'Asia/Phnom_Penh' },
  { label: 'Asia/Pontianak', value: 'Asia/Pontianak' },
  { label: 'Asia/Pyongyang', value: 'Asia/Pyongyang' },
  { label: 'Asia/Qatar', value: 'Asia/Qatar' },
  { label: 'Asia/Qostanay', value: 'Asia/Qostanay' },
  { label: 'Asia/Qyzylorda', value: 'Asia/Qyzylorda' },
  { label: 'Asia/Riyadh', value: 'Asia/Riyadh' },
  { label: 'Asia/Sakhalin', value: 'Asia/Sakhalin' },
  { label: 'Asia/Samarkand', value: 'Asia/Samarkand' },
  { label: 'Asia/Seoul', value: 'Asia/Seoul' },
  { label: 'Asia/Shanghai', value: 'Asia/Shanghai' },
  { label: 'Asia/Singapore', value: 'Asia/Singapore' },
  { label: 'Asia/Srednekolymsk', value: 'Asia/Srednekolymsk' },
  { label: 'Asia/Taipei', value: 'Asia/Taipei' },
  { label: 'Asia/Tashkent', value: 'Asia/Tashkent' },
  { label: 'Asia/Tbilisi', value: 'Asia/Tbilisi' },
  { label: 'Asia/Tehran', value: 'Asia/Tehran' },
  { label: 'Asia/Thimphu', value: 'Asia/Thimphu' },
  { label: 'Asia/Tokyo', value: 'Asia/Tokyo' },
  { label: 'Asia/Tomsk', value: 'Asia/Tomsk' },
  { label: 'Asia/Ulaanbaatar', value: 'Asia/Ulaanbaatar' },
  { label: 'Asia/Urumqi', value: 'Asia/Urumqi' },
  { label: 'Asia/Ust-Nera', value: 'Asia/Ust-Nera' },
  { label: 'Asia/Vientiane', value: 'Asia/Vientiane' },
  { label: 'Asia/Vladivostok', value: 'Asia/Vladivostok' },
  { label: 'Asia/Yakutsk', value: 'Asia/Yakutsk' },
  { label: 'Asia/Yangon', value: 'Asia/Yangon' },
  { label: 'Asia/Yekaterinburg', value: 'Asia/Yekaterinburg' },
  { label: 'Asia/Yerevan', value: 'Asia/Yerevan' },
  { label: 'Atlantic/Azores', value: 'Atlantic/Azores' },
  { label: 'Atlantic/Bermuda', value: 'Atlantic/Bermuda' },
  { label: 'Atlantic/Canary', value: 'Atlantic/Canary' },
  { label: 'Atlantic/Cape_Verde', value: 'Atlantic/Cape_Verde' },
  { label: 'Atlantic/Faroe', value: 'Atlantic/Faroe' },
  { label: 'Atlantic/Madeira', value: 'Atlantic/Madeira' },
  { label: 'Atlantic/Reykjavik', value: 'Atlantic/Reykjavik' },
  { label: 'Atlantic/South_Georgia', value: 'Atlantic/South_Georgia' },
  { label: 'Atlantic/St_Helena', value: 'Atlantic/St_Helena' },
  { label: 'Atlantic/Stanley', value: 'Atlantic/Stanley' },
  { label: 'Australia/Adelaide', value: 'Australia/Adelaide' },
  { label: 'Australia/Brisbane', value: 'Australia/Brisbane' },
  { label: 'Australia/Broken_Hill', value: 'Australia/Broken_Hill' },
  { label: 'Australia/Currie', value: 'Australia/Currie' },
  { label: 'Australia/Darwin', value: 'Australia/Darwin' },
  { label: 'Australia/Eucla', value: 'Australia/Eucla' },
  { label: 'Australia/Hobart', value: 'Australia/Hobart' },
  { label: 'Australia/Lindeman', value: 'Australia/Lindeman' },
  { label: 'Australia/Lord_Howe', value: 'Australia/Lord_Howe' },
  { label: 'Australia/Melbourne', value: 'Australia/Melbourne' },
  { label: 'Australia/Perth', value: 'Australia/Perth' },
  { label: 'Australia/Sydney', value: 'Australia/Sydney' },
  { label: "Australia/Adelaide", value: "Australia/Adelaide" },
  { label: "Australia/Brisbane", value: "Australia/Brisbane" },
  { label: "Australia/Broken_Hill", value: "Australia/Broken_Hill" },
  { label: "Australia/Currie", value: "Australia/Currie" },
  { label: "Australia/Darwin", value: "Australia/Darwin" },
  { label: "Australia/Eucla", value: "Australia/Eucla" },
  { label: "Australia/Hobart", value: "Australia/Hobart" },
  { label: "Australia/Lindeman", value: "Australia/Lindeman" },
  { label: "Australia/Lord_Howe", value: "Australia/Lord_Howe" },
  { label: "Australia/Melbourne", value: "Australia/Melbourne" },
  { label: "Australia/Perth", value: "Australia/Perth" },
  { label: "Australia/Sydney", value: "Australia/Sydney" },
  { label: "Australia/Yancowinna", value: "Australia/Yancowinna" },
  { label: "Australia/ACT", value: "Australia/ACT" },
  { label: "Australia/North", value: "Australia/North" },
  { label: "Australia/NSW", value: "Australia/NSW" },
  { label: "Australia/Queensland", value: "Australia/Queensland" },
  { label: "Australia/South", value: "Australia/South" },
  { label: "Australia/Tasmania", value: "Australia/Tasmania" },
  { label: "Australia/Victoria", value: "Australia/Victoria" },
  { label: "Australia/West", value: "Australia/West" },
  { label: "Brazil/Acre", value: "Brazil/Acre" },
  { label: "Brazil/DeNoronha", value: "Brazil/DeNoronha" },
  { label: "Brazil/East", value: "Brazil/East" },
  { label: "Brazil/West", value: "Brazil/West" },
  { label: "CET", value: "CET" },
  { label: "CST6CDT", value: "CST6CDT" },
  { label: 'Canada/Newfoundland', value: 'Canada/Newfoundland' },
  { label: 'Canada/Atlantic', value: 'Canada/Atlantic' },
  { label: 'Canada/Eastern', value: 'Canada/Eastern' },
  { label: 'Canada/Central', value: 'Canada/Central' },
  { label: 'Canada/Mountain', value: 'Canada/Mountain' },
  { label: 'Canada/Pacific', value: 'Canada/Pacific' },
  { label: 'Canada/Yukon', value: 'Canada/Yukon' },
  { label: 'Canada/Saskatchewan', value: 'Canada/Saskatchewan' },
  { label: 'Europe/London', value: 'Europe/London' },
  { label: 'Europe/Amsterdam', value: 'Europe/Amsterdam' },
  { label: 'Europe/Andorra', value: 'Europe/Andorra' },
  { label: 'Europe/Astrakhan', value: 'Europe/Astrakhan' },
  { label: 'Europe/Athens', value: 'Europe/Athens' },
  { label: 'Europe/Belgrade', value: 'Europe/Belgrade' },
  { label: 'Europe/Berlin', value: 'Europe/Berlin' },
  { label: 'Europe/Bratislava', value: 'Europe/Bratislava' },
  { label: 'Europe/Brussels', value: 'Europe/Brussels' },
  { label: 'Europe/Bucharest', value: 'Europe/Bucharest' },
  { label: 'Europe/Budapest', value: 'Europe/Budapest' },
  { label: 'Europe/Busingen', value: 'Europe/Busingen' },
  { label: 'Europe/Chisinau', value: 'Europe/Chisinau' },
  { label: 'Europe/Copenhagen', value: 'Europe/Copenhagen' },
  { label: 'Europe/Dublin', value: 'Europe/Dublin' },
  { label: 'Europe/Gibraltar', value: 'Europe/Gibraltar' },
  { label: 'Europe/Guernsey', value: 'Europe/Guernsey' },
  { label: 'Europe/Helsinki', value: 'Europe/Helsinki' },
  { label: 'Europe/Isle_of_Man', value: 'Europe/Isle_of_Man' },
  { label: 'Europe/Istanbul', value: 'Europe/Istanbul' },
  { label: 'Europe/Jersey', value: 'Europe/Jersey' },
  { label: 'Europe/Kaliningrad', value: 'Europe/Kaliningrad' },
  { label: 'Europe/Kiev', value: 'Europe/Kiev' },
  { label: 'Europe/Kirov', value: 'Europe/Kirov' },
  { label: 'Europe/Lisbon', value: 'Europe/Lisbon' },
  { label: 'Europe/Ljubljana', value: 'Europe/Ljubljana' },
  { label: 'Europe/Luxembourg', value: 'Europe/Luxembourg' },
  { label: 'Europe/Madrid', value: 'Europe/Madrid' },
  { label: 'Europe/Malta', value: 'Europe/Malta' },
  { label: 'Europe/Mariehamn', value: 'Europe/Mariehamn' },
  { label: 'Europe/Minsk', value: 'Europe/Minsk' },
  { label: 'Europe/Monaco', value: 'Europe/Monaco' },
  { label: 'Europe/Moscow', value: 'Europe/Moscow' },
  { label: 'Europe/Oslo', value: 'Europe/Oslo' },
  { label: 'Europe/Paris', value: 'Europe/Paris' },
  { label: 'Europe/Podgorica', value: 'Europe/Podgorica' },
  { label: 'Europe/Prague', value: 'Europe/Prague' },
  { label: 'Europe/Riga', value: 'Europe/Riga' },
  { label: 'Europe/Rome', value: 'Europe/Rome' },
  { label: 'Europe/Samara', value: 'Europe/Samara' },
  { label: 'Europe/San_Marino', value: 'Europe/San_Marino' },
  { label: 'Europe/Sarajevo', value: 'Europe/Sarajevo' },
  { label: 'Europe/Saratov', value: 'Europe/Saratov' },
  { label: 'Europe/Simferopol', value: 'Europe/Simferopol' },
  { label: 'Europe/Skopje', value: 'Europe/Skopje' },
  { label: 'Europe/Sofia', value: 'Europe/Sofia' },
  { label: 'Europe/Stockholm', value: 'Europe/Stockholm' },
  { label: 'Europe/Tallinn', value: 'Europe/Tallinn' },
  { label: 'Europe/Tirane', value: 'Europe/Tirane' },
  { label: 'Europe/Ulyanovsk', value: 'Europe/Ulyanovsk' },
  { label: 'Europe/Uzhgorod', value: 'Europe/Uzhgorod' },
  { label: 'Europe/Vaduz', value: 'Europe/Vaduz' },
  { label: 'Europe/Vatican', value: 'Europe/Vatican' },
  { label: 'Europe/Vienna', value: 'Europe/Vienna' },
  { label: 'Europe/Vilnius', value: 'Europe/Vilnius' },
  { label: 'Europe/Volgograd', value: 'Europe/Volgograd' },
  { label: 'Europe/Warsaw', value: 'Europe/Warsaw' },
  { label: 'Europe/Zagreb', value: 'Europe/Zagreb' },
  { label: 'Europe/Zaporozhye', value: 'Europe/Zaporozhye' },
  { label: 'Europe/Zurich', value: 'Europe/Zurich' }
];

export const DIRECT_HIRE = 'DIRECT_HIRE';
export const AWAITING_EXECUTIVE_APPROVAL = 'AWAITING_EXECUTIVE_APPROVAL'
export const AGREEMENT_STATUS_UNDELIVERABLE = 'UNDELIVERABLE';
export const ACCOUNTING_INVOICED = 'ACCOUNTING_INVOICED';
export const ACCOUNTING_APPROVED = 'ACCOUNTING_APPROVED';
export const PAID = 'PAID';
export const REQUEST_PLACEMENT_CANCELLED = 'REQUEST_PLACEMENT_CANCELLED';
export const ACCOUNTING_MANAGER_ROLE = 'ACCOUNTING_MANAGER';
export const EXECUTIVE_ROLE = 'EXECUTIVE';
export const ADMIN_ROLE = 'ADMIN';
export const HR_ROLE = 'HR';
export const ACCOUNTING_COORDINATOR_ROLE = 'ACCOUNTING_COORDINATOR';
export const PERCENTAGE = 'PERCENTAGE';
export const COMPANY_CONTACT_HEADER = ["Full Name", "job Title", "Primary Email", 'Phone', "Preferred Contact"];
export const UK = 'UK';
export const YES = 'Yes';
export const NO = 'No';

export const MODULE_ACCESS_OPTIONS = [
  { label: 'GLOBAL', value: 'Global' },
  { label: 'INDIVIDUAL', value: 'Individual' },
];
export const MODULE_OPTIONS = [
  { label: 'CHATGPT', value: 'ChatGPT' },
  { label: 'RESUME_REFORMATTER', value: 'Resume Reformater' },
  { label: 'ADVANCE_CANDIDATE_SEARCH', value: "Advance Candidate Search" },
  { label: 'JOB_LIST', value: "Job List" },
  { label: 'AI_MATCH_SCORING', value: "AI Match Scoring" },
  { label: 'AGED_INVOICES', value: 'Aged Invoices' },
  { label: 'CANDIDATE_RECOMMENDATIONS', value: 'Candidate Recommendations' },
  { label: 'MY_EARNING', value: 'My Earning' },
  { label: 'AI_REFERENCE_TAKER', value: 'AI Reference Taker' },
];

export const PENDING_EXECUTIVE_APPROVAL = 'PENDING_EXECUTIVE_APPROVAL';
export const DRAFT = 'DRAFT';
export const MANAGER_REJECTED = 'MANAGER_REJECTED';
export const EXECUTIVE_REJECTED = 'EXECUTIVE_REJECTED';
export const CLIENT_PREVIEW = 'CLIENT_PREVIEW';
export const MANAGER = 'MANAGER';
export const TEMP = 'TEMP';
export const CUSTOM = 'CUSTOM';
export const AWAITING_MANAGER_APPROVAL = 'AWAITING_MANAGER_APPROVAL';
export const OUT_FOR_SIGNATURE = 'OUT_FOR_SIGNATURE';
export const SIGNED = 'SIGNED';
export const EXECUTIVE_APPROVED = 'EXECUTIVE_APPROVED';
export const RESENT = 'RESENT';
export const UNDELIVERABLE = 'UNDELIVERABLE';
export const VOIDED = 'VOIDED';
export const CLIENT_REJECTED = 'CLIENT_REJECTED';
export const ALL_FIELDS_REQUIRED_MSG = "all fields are required!"

export const CHATGPTMODULE_OPTIONS = [
  { label: 'Good Have Skills', value: 'GOOD_HAVE_SKILS' },
  { label: 'Interview Evaluation', value: 'INTERVIEW_EVALUATION' },
  { label: 'Interview Questions', value: 'INTERVIEW_QUESTIONS' },
  { label: "Must Have Skills", value: 'MUST_HAVE_SKILS' },
  { label: "Reference Extraction", value: 'REFERENCE_EXTRACTION' },
  { label: "Resume Scoring", value: 'RESUME_SCORING' },
  { label: "Resume Summary", value: 'RESUME_SUMMARY' },
  { label: "Update Candidate From Resume", value: 'UPDATE_CANDIDATE_FROM_RESUME' },
];

export const EMAIL_TEMPLATES_OPTIONS = [
  { label: 'User Activity Report', value: 'User Activity Report' },
  { label: 'Invoice Email', value: 'Invoice Email' },
  { label: 'Invoice Aged Email', value: 'Invoice Aged Email' },
  { label: 'AI Recruiter Outreach', value: 'AI Recruiter Outreach' },
  { label: 'AI Recruiter Outreach Retry', value: 'AI Recruiter Outreach Retry' },
  { label: 'AI Recruiter Reschedule', value: 'AI Recruiter Reschedule' },
  { label: 'AI Recruiter Interview Confirmation', value: 'AI Recruiter Interview Confirmation' },
  { label: 'AI Reference Outreach', value: 'AI Reference Outreach' },
  { label: 'AI Reference Outreach Retry', value: 'AI Reference Outreach Retry' },
  { label: 'AI Reference Confirmation', value: 'AI Reference Confirmation' },
  { label: 'AI Reference Reschedule', value: 'AI Reference Reschedule' },
]

export type ChatGPTTemplate = {
  __typename: string;
  id: string;
  updatedAt: string;
  createdAt: string;
  template: string;
  module: string;
};

//Invoice Email Content string
export const INVOICE_EMAIL_CONTENT = "Invoice Email Content"
//Invoice Number string
export const INVOICE_NUMBER = "Invoice Number"

//STATUS CODE
export const PRIMARY = 'primary';
export const DARK = 'dark';
export const SECONDARY = 'secondary';
export const WARNING = 'warning';
export const CONTACT = 'contact';
export const DANGER = 'danger';
export const INFO = 'info';
export const SUCCESS = 'success';
export const LEGAL_DIRECT_HIRE = 'LEGAL_DIRECT_HIRE';
export const LEGAL_CONTRACT = 'LEGAL_CONTRACT';

export const EMAIL_NOTES_FOR_CONTACTS = [
  "Category",
  "Subject",
  "Created By",
  "Date Sent",
  "Actions",
];

export const TOAST_COMMON_MSG = {
  ADDED_SUCCESS: 'added successfully',
  ADDED_ERROR: 'error while adding',
  REMOVED_SUCCESS: 'removed successfully',
  REMOVED_ERROR: 'error while removing'
}
//Invoice Status 
export const INVOICE_SENT = 'INVOICE_SENT'
export const INVOICE_SCHEDULED = 'INVOICE_SCHEDULED'
export const REMINDER_SENT = 'REMINDER_SENT'
export const PAYMENT_RECEIVED = 'PAYMENT_RECEIVED'

export const INVOICE_TO_BE_SENT_TEXT = 'Invoice to be sent on'

//Data CSV Imports Status
export const FAILED_IMPORT = 'Failed'
export const SUCCESS_IMPORT = 'Success'
export const UPLOADING_IMPORT = 'Uploading'

export const recruiterDealTemplate = {
  subject: `<p><strong>Subject:</strong> ("<u>Compensation Schedule</u>") – {{fullName}} (“you” or “your” or “Employee”)</p>`,
  body: `<p >This Compensation Schedule is an Addendum to the Compensation Agreement, together make up the (“Agreement”) is entered into this day {{date}} (“Start Date”) between RealREPP, LLC (the “Company”) and the Employee. The Company and I are pleased to offer you this opportunity and compensation terms outlined in the Agreement. Employee will be compensated based on the terms of the Agreement provided that you are in agreement with the terms as indicated herein. This Addendum between the parties supersedes all prior and contemporaneous Addendum negotiations and understandings between the parties whether oral or written, expressed or implied with regards to compensation and Compensation Schedule. This Agreement may not be amended, except by writing or an additional Addendum executed between Company and Employee</p><p><br></p><p >As a {{recruiterTitle}}, your responsibilities include, but are not limited to ownership of full cycle recruitment, develop, build, retain strong candidate pipelines, business development, account management, cultivate new business, engage clients throughout the year, consistently building client pipelines, develop client ownership through consistent onboarding of new clients and growing a repeat client customer base by building existing/previous client relationships, mentor and develop new associates.</p>`,
  compensationTerms: `Salary, Additional Compensation`,
  biweeklySalary: '{{biWeeklySalary}} ({{annualEquivalent}} annual equivalent)',
  dhBaseRate: '{{dhBaseRate}}',
  tempBaseRate: '{{tempBaseRate}}',
  commissionPaid: `<p><strong><em>-Commission Paid/Advanced</em></strong>: in the period check is received from Client, Client Guarantee Period terms apply. -If Bi-weekly = $1,000; Commission = $4,000; additional amount after bi-weekly / (shortfall) = $3,000 ***Incentives – Additional Compensation added to the Direct Hire Base Rate. Additional Incentive is added to the Direct Hire Base Rate in the period following achievement and Incentive will be applied to all Direct Hire placements thereafter (Base Rate % + Incentive %). For example: If Employee achieves <span style="color: rgb(230, 0, 0);">incentive target</span> Billing Credits as calculated on April’s Period End Monthly Report, the Incentive Rate will be assessed on all Direct Hire placements where Candidate <span style="color: rgb(230, 0, 0);">start Date</span> occurs on or after May 1st (“Effective Date”). At the start of each Calendar year, the prior year Incentives drop off and reset to Base Rate and Billing Credits used to calculate Incentives reset to zero (“0”) upon the start of the new Calendar year commencing January 1st.</p><br><p>****New Client Bonus: As founding Account Manager (AM) / Client Owner you qualify on the account side of the placement and if also the founding Recruiter (REC) you qualify on the recruiting side of the placement. Must be founding AM (i.e. Client Owner) to qualify for New Client Bonus. To be a founding REC, you must also be Client owner (i.e. founding AM). If you are not the founding recruiter on a first placement for a new client, your recruiting commission rate would be your DH Base Rate (including any earned Incentive tiers at time of placement). New Client Bonus applies to only the first placement at your new client.</p>`,
  conditions: `<p><em>RealREPP is an equal opportunity employer. Acceptance of this offer of employment is at-will, and this letter does not constitute an employment contract. This means that the employee and employer can terminate the employment relationship at any time. RealREPP reserves the right to modify bi-weekly, bonus incentives and/or Additional Compensation arrangements with advanced notification to employee</em></p>`,
}

export const recruiterDealTemplate2 = {
  subject: `<p><strong>Subject:</strong> ("<u>Compensation Schedule</u>") – {{fullName}} (“you” or “your” or “Employee”)</p>`,
  body: `<p >This Compensation Schedule is an Addendum to the Compensation Agreement, together make up the (“Agreement”) is entered into this day {{date}} (“Start Date”) between RealREPP, LLC (the “Company”) and the Employee. The Company and I are pleased to offer you this opportunity and compensation terms outlined in the Agreement. Employee will be compensated based on the terms of the Agreement provided that you are in agreement with the terms as indicated herein. This Addendum between the parties supersedes all prior and contemporaneous Addendum negotiations and understandings between the parties whether oral or written, expressed or implied with regards to compensation and Compensation Schedule. This Agreement may not be amended, except by writing or an additional Addendum executed between Company and Employee</p><p><br></p><p >As a {{recruiterTitle}}, your responsibilities include, but are not limited to ownership of full cycle recruitment, develop, build, retain strong candidate pipelines, business development, account management, cultivate new business, engage clients throughout the year, consistently building client pipelines, develop client ownership through consistent onboarding of new clients and growing a repeat client customer base by building existing/previous client relationships, mentor and develop new associates.</p>`,
  compensationTerms: `Salary, Additional Compensation`,
  biweeklySalary: '{{biWeeklySalary}} ({{annualEquivalent}} annual equivalent)',
  dhBaseRate: '{{dhBaseRate}}',
  tempBaseRate: '{{tempBaseRate}}',
  commissionPaid: `<p><strong><em>-Commission Paid/Advanced</em></strong>: in the period check is received from Client, Client Guarantee Period terms apply.</p><p>-If Bi-weekly = $1,000; Commission = $4,000; additional amount after bi-weekly / (shortfall) = $3,000 commission earned net of your base.</p><p>*(“Non-recoverable”) Period 0-90 days from start date: shortfall amounts do not carry forward to next period.</p><p>**(“Recoverable”) Period 91+ days from start date: shortfall amounts carry forward to the next period.</p><p>***Incentives – Additional Compensation added to the Direct Hire Base Rate. Additional Incentive is added to the Direct Hire Base Rate in the period following achievement and Incentive will be applied to all Direct Hire placements thereafter (Base Rate % + Incentive %). For example: If Employee achieves <span style="color: rgb(230, 0, 0);">incentive target</span> Billing Credits as calculated on April’s Period End Monthly Report, the Incentive Rate will be assessed on all Direct Hire placements where Candidate <span style="color: rgb(230, 0, 0);">start Date</span> occurs on or after May 1st (“Effective Date”). At the start of each Calendar year, the prior year Incentives drop off and reset to Base Rate and Billing Credits used to calculate Incentives reset to zero (“0”) upon the start of the new Calendar year commencing January 1st.</p><br><br><p>****New Client Bonus: As founding Account Manager (AM) / Client Owner you qualify on the account side of the placement and if also the founding Recruiter (REC) you qualify on the recruiting side of the placement. Must be founding AM (i.e. Client Owner) to qualify for New Client Bonus. To be a founding REC, you must also be Client owner (i.e. founding AM). If you are not the founding recruiter on a first placement for a new client, your recruiting commission rate would be your DH Base Rate (including any earned Incentive tiers at time of placement). New Client Bonus applies to only the first placement at your new client.</p>`,
  conditions: `<p><em>RealREPP is an equal opportunity employer. Acceptance of this offer of employment is at-will, and this letter does not constitute an employment contract. This means that the employee and employer can terminate the employment relationship at any time. RealREPP reserves the right to modify bi-weekly, bonus incentives and/or Additional Compensation arrangements with advanced notification to employee</em></p>`,
}

export const RECRUITER_DEAL_TEMPLATES_HEADERS = {
  RECOVERABLE_DRAW: "Recoverable Draw",
  SUBJECT: "Subject",
  BODY: "Body",
  COMPENSATION_TERMS: "Compensation Terms",
  BIWEEKLY_SALARY: "Bi-weekly Salary, draw against Commission",
  DH_BASE_RATE: "Direct Hire (DH) - Commission Bonus Base Rate",
  TEMP_BASE_RATE: "Temporary or Temp - Commission Bonus Base Rate",
  CONDITIONS: "Conditions",
}

export const RECRUITER_DEAL_INPUTS_PLACEHOLDERS = {
  COMPENSATION_TERMS: "Compensation Terms Template",
  BIWEEKLY_SALARY: "Bi-weekly Salary Template",
  DH_BASE_RATE: "DH Base Rate Template",
  TEMP_BASE_RATE: "Temp Base Rate Template",
}

